interface IconProps {
  className?: string;
  size?: number;
  color?: string;
}

export const BaseProfileIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8C14.6666 4.3181 11.6818 1.33333 7.99992 1.33333C4.31802 1.33333 1.33325 4.3181 1.33325 8C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.66667C9.10457 8.66667 10 7.77124 10 6.66667C10 5.5621 9.10457 4.66667 8 4.66667C6.89543 4.66667 6 5.5621 6 6.66667C6 7.77124 6.89543 8.66667 8 8.66667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66675 13.7747V12.6667C4.66675 12.313 4.80722 11.9739 5.05727 11.7239C5.30732 11.4738 5.64646 11.3333 6.00008 11.3333H10.0001C10.3537 11.3333 10.6928 11.4738 10.9429 11.7239C11.1929 11.9739 11.3334 12.313 11.3334 12.6667V13.7747"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AdvisorPreferencesIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8C14.6666 4.3181 11.6818 1.33333 7.99992 1.33333C4.31802 1.33333 1.33325 4.3181 1.33325 8C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00008 9.33334C8.73646 9.33334 9.33341 8.73638 9.33341 8.00001C9.33341 7.26363 8.73646 6.66667 8.00008 6.66667C7.2637 6.66667 6.66675 7.26363 6.66675 8.00001C6.66675 8.73638 7.2637 9.33334 8.00008 9.33334Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AccountSettingsIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.14667 1.33333H7.85333C7.49971 1.33333 7.16057 1.4738 6.91053 1.72385C6.66048 1.9739 6.52 2.31304 6.52 2.66666V2.78666C6.51976 3.02048 6.45804 3.25012 6.34103 3.45255C6.22401 3.65498 6.05583 3.82309 5.85333 3.93999L5.56667 4.10666C5.36398 4.22369 5.13405 4.28529 4.9 4.28529C4.66595 4.28529 4.43603 4.22369 4.23333 4.10666L4.13333 4.05333C3.82738 3.87684 3.46389 3.82896 3.12267 3.9202C2.78145 4.01144 2.49037 4.23435 2.31333 4.53999L2.16667 4.79333C1.99018 5.09929 1.9423 5.46277 2.03354 5.80399C2.12478 6.14522 2.34769 6.43629 2.65333 6.61333L2.75333 6.68C2.95485 6.79634 3.12241 6.96339 3.23937 7.16455C3.35632 7.36571 3.4186 7.59398 3.42 7.82666V8.16666C3.42093 8.40161 3.35977 8.63263 3.2427 8.83633C3.12563 9.04004 2.95681 9.20919 2.75333 9.32666L2.65333 9.38666C2.34769 9.5637 2.12478 9.85477 2.03354 10.196C1.9423 10.5372 1.99018 10.9007 2.16667 11.2067L2.31333 11.46C2.49037 11.7656 2.78145 11.9885 3.12267 12.0798C3.46389 12.171 3.82738 12.1232 4.13333 11.9467L4.23333 11.8933C4.43603 11.7763 4.66595 11.7147 4.9 11.7147C5.13405 11.7147 5.36398 11.7763 5.56667 11.8933L5.85333 12.06C6.05583 12.1769 6.22401 12.345 6.34103 12.5474C6.45804 12.7499 6.51976 12.9795 6.52 13.2133V13.3333C6.52 13.687 6.66048 14.0261 6.91053 14.2761C7.16057 14.5262 7.49971 14.6667 7.85333 14.6667H8.14667C8.50029 14.6667 8.83943 14.5262 9.08948 14.2761C9.33953 14.0261 9.48 13.687 9.48 13.3333V13.2133C9.48024 12.9795 9.54196 12.7499 9.65898 12.5474C9.77599 12.345 9.94418 12.1769 10.1467 12.06L10.4333 11.8933C10.636 11.7763 10.866 11.7147 11.1 11.7147C11.3341 11.7147 11.564 11.7763 11.7667 11.8933L11.8667 11.9467C12.1726 12.1232 12.5361 12.171 12.8773 12.0798C13.2186 11.9885 13.5096 11.7656 13.6867 11.46L13.8333 11.2C14.0098 10.894 14.0577 10.5306 13.9665 10.1893C13.8752 9.84811 13.6523 9.55703 13.3467 9.37999L13.2467 9.32666C13.0432 9.20919 12.8744 9.04004 12.7573 8.83633C12.6402 8.63263 12.5791 8.40161 12.58 8.16666V7.83333C12.5791 7.59838 12.6402 7.36736 12.7573 7.16366C12.8744 6.95995 13.0432 6.7908 13.2467 6.67333L13.3467 6.61333C13.6523 6.43629 13.8752 6.14522 13.9665 5.80399C14.0577 5.46277 14.0098 5.09929 13.8333 4.79333L13.6867 4.53999C13.5096 4.23435 13.2186 4.01144 12.8773 3.9202C12.5361 3.82896 12.1726 3.87684 11.8667 4.05333L11.7667 4.10666C11.564 4.22369 11.3341 4.28529 11.1 4.28529C10.866 4.28529 10.636 4.22369 10.4333 4.10666L10.1467 3.93999C9.94418 3.82309 9.77599 3.65498 9.65898 3.45255C9.54196 3.25012 9.48024 3.02048 9.48 2.78666V2.66666C9.48 2.31304 9.33953 1.9739 9.08948 1.72385C8.83943 1.4738 8.50029 1.33333 8.14667 1.33333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CurrentRoleIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.6666 13.3333V2.66667C10.6666 2.31304 10.5261 1.9739 10.2761 1.72386C10.026 1.47381 9.68687 1.33333 9.33325 1.33333H6.66659C6.31296 1.33333 5.97383 1.47381 5.72378 1.72386C5.47373 1.9739 5.33325 2.31304 5.33325 2.66667V13.3333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 4H2.66659C1.93021 4 1.33325 4.59695 1.33325 5.33333V12C1.33325 12.7364 1.93021 13.3333 2.66659 13.3333H13.3333C14.0696 13.3333 14.6666 12.7364 14.6666 12V5.33333C14.6666 4.59695 14.0696 4 13.3333 4Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FunctionIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4 14.6667V2.66667C4 2.31304 4.14048 1.9739 4.39052 1.72386C4.64057 1.47381 4.97971 1.33333 5.33333 1.33333H10.6667C11.0203 1.33333 11.3594 1.47381 11.6095 1.72386C11.8595 1.9739 12 2.31304 12 2.66667V14.6667H4Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99992 8H2.66659C2.31296 8 1.97382 8.14048 1.72378 8.39052C1.47373 8.64057 1.33325 8.97971 1.33325 9.33333V13.3333C1.33325 13.687 1.47373 14.0261 1.72378 14.2761C1.97382 14.5262 2.31296 14.6667 2.66659 14.6667H3.99992"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6H13.3333C13.687 6 14.0261 6.14048 14.2761 6.39052C14.5262 6.64057 14.6667 6.97971 14.6667 7.33333V13.3333C14.6667 13.687 14.5262 14.0261 14.2761 14.2761C14.0261 14.5262 13.687 14.6667 13.3333 14.6667H12"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66675 4H9.33341"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66675 6.66667H9.33341"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66675 9.33333H9.33341"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66675 12H9.33341"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BriefcaseIcon = ({ className, size = 11 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.33317 9.16699V1.83366C7.33317 1.59054 7.23659 1.35739 7.06469 1.18548C6.89278 1.01357 6.65962 0.916992 6.4165 0.916992H4.58317C4.34006 0.916992 4.1069 1.01357 3.93499 1.18548C3.76308 1.35739 3.6665 1.59054 3.6665 1.83366V9.16699"
      stroke="currentColor"
      strokeWidth="0.916667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16675 2.75H1.83341C1.32715 2.75 0.916748 3.16041 0.916748 3.66667V8.25C0.916748 8.75626 1.32715 9.16667 1.83341 9.16667H9.16675C9.67301 9.16667 10.0834 8.75626 10.0834 8.25V3.66667C10.0834 3.16041 9.67301 2.75 9.16675 2.75Z"
      stroke="currentColor"
      strokeWidth="0.916667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LocationIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.3334 6.66667C13.3334 9.99533 9.64075 13.462 8.40075 14.5327C8.28523 14.6195 8.14461 14.6665 8.00008 14.6665C7.85555 14.6665 7.71493 14.6195 7.59941 14.5327C6.35941 13.462 2.66675 9.99533 2.66675 6.66667C2.66675 5.25218 3.22865 3.89562 4.22885 2.89543C5.22904 1.89524 6.58559 1.33333 8.00008 1.33333C9.41457 1.33333 10.7711 1.89524 11.7713 2.89543C12.7715 3.89562 13.3334 5.25218 13.3334 6.66667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.66667C9.10457 8.66667 10 7.77124 10 6.66667C10 5.5621 9.10457 4.66667 8 4.66667C6.89543 4.66667 6 5.5621 6 6.66667C6 7.77124 6.89543 8.66667 8 8.66667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IndustryIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8C14.6666 4.3181 11.6818 1.33333 7.99992 1.33333C4.31802 1.33333 1.33325 4.3181 1.33325 8C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99992 1.33333C6.28807 3.13077 5.33325 5.51783 5.33325 8C5.33325 10.4822 6.28807 12.8692 7.99992 14.6667C9.71176 12.8692 10.6666 10.4822 10.6666 8C10.6666 5.51783 9.71176 3.13077 7.99992 1.33333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33325 8H14.6666"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BioIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.4999 1.66666H4.99992C4.55789 1.66666 4.13397 1.84226 3.82141 2.15482C3.50885 2.46738 3.33325 2.8913 3.33325 3.33333V16.6667C3.33325 17.1087 3.50885 17.5326 3.82141 17.8452C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8452C16.491 17.5326 16.6666 17.1087 16.6666 16.6667V5.83333L12.4999 1.66666Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 1.66666V5C11.6667 5.44202 11.8423 5.86595 12.1549 6.17851C12.4675 6.49107 12.8914 6.66666 13.3334 6.66666H16.6667"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33341 7.5H6.66675"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3334 10.8333H6.66675"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3334 14.1667H6.66675"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PencilIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.1161 4.54134C14.4686 4.18895 14.6666 3.71098 14.6667 3.21257C14.6668 2.71416 14.4688 2.23614 14.1165 1.88367C13.7641 1.5312 13.2861 1.33315 12.7877 1.33308C12.2893 1.33302 11.8113 1.53095 11.4588 1.88334L2.56145 10.7827C2.40667 10.937 2.29219 11.127 2.22812 11.336L1.34745 14.2373C1.33022 14.295 1.32892 14.3562 1.34369 14.4146C1.35845 14.4729 1.38873 14.5262 1.43132 14.5687C1.4739 14.6112 1.5272 14.6414 1.58556 14.6561C1.64392 14.6707 1.70516 14.6693 1.76279 14.652L4.66479 13.772C4.87357 13.7085 5.06357 13.5947 5.21812 13.4407L14.1161 4.54134Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GrowthAreasIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_695_24)">
      <path
        d="M6.6243 10.3332C6.56478 10.1025 6.44453 9.89191 6.27605 9.72343C6.10757 9.55495 5.89702 9.43469 5.6663 9.37517L1.5763 8.32051C1.50652 8.3007 1.44511 8.25867 1.40138 8.2008C1.35765 8.14293 1.33398 8.07238 1.33398 7.99984C1.33398 7.9273 1.35765 7.85675 1.40138 7.79888C1.44511 7.74101 1.50652 7.69898 1.5763 7.67917L5.6663 6.62384C5.89693 6.56438 6.10743 6.44422 6.2759 6.27587C6.44438 6.10751 6.56468 5.8971 6.6243 5.66651L7.67897 1.57651C7.69857 1.50645 7.74056 1.44474 7.79851 1.40077C7.85647 1.35681 7.92722 1.33301 7.99997 1.33301C8.07271 1.33301 8.14346 1.35681 8.20142 1.40077C8.25938 1.44474 8.30136 1.50645 8.32097 1.57651L9.37497 5.66651C9.43449 5.89722 9.55474 6.10777 9.72322 6.27625C9.8917 6.44473 10.1023 6.56499 10.333 6.62451L14.423 7.67851C14.4933 7.69791 14.5553 7.73985 14.5995 7.79789C14.6437 7.85594 14.6677 7.92688 14.6677 7.99984C14.6677 8.0728 14.6437 8.14374 14.5995 8.20179C14.5553 8.25983 14.4933 8.30177 14.423 8.32117L10.333 9.37517C10.1023 9.43469 9.8917 9.55495 9.72322 9.72343C9.55474 9.89191 9.43449 10.1025 9.37497 10.3332L8.3203 14.4232C8.3007 14.4932 8.25871 14.5549 8.20075 14.5989C8.1428 14.6429 8.07205 14.6667 7.9993 14.6667C7.92656 14.6667 7.85581 14.6429 7.79785 14.5989C7.73989 14.5549 7.69791 14.4932 7.6783 14.4232L6.6243 10.3332Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 2V4.66667"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 3.33334H12"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66602 11.333V12.6663"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 12H2"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_695_24">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinkedInIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.6667 5.33331C11.7276 5.33331 12.745 5.75474 13.4952 6.50489C14.2453 7.25503 14.6667 8.27245 14.6667 9.33331V14H12.0001V9.33331C12.0001 8.97969 11.8596 8.64055 11.6096 8.3905C11.3595 8.14046 11.0204 7.99998 10.6667 7.99998C10.3131 7.99998 9.97399 8.14046 9.72394 8.3905C9.47389 8.64055 9.33341 8.97969 9.33341 9.33331V14H6.66675V9.33331C6.66675 8.27245 7.08818 7.25503 7.83832 6.50489C8.58847 5.75474 9.60588 5.33331 10.6667 5.33331Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99992 6H1.33325V14H3.99992V6Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66659 3.99998C3.40297 3.99998 3.99992 3.40303 3.99992 2.66665C3.99992 1.93027 3.40297 1.33331 2.66659 1.33331C1.93021 1.33331 1.33325 1.93027 1.33325 2.66665C1.33325 3.40303 1.93021 3.99998 2.66659 3.99998Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PesonalWebsiteIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.99992 14.6666C11.6818 14.6666 14.6666 11.6819 14.6666 7.99998C14.6666 4.31808 11.6818 1.33331 7.99992 1.33331C4.31802 1.33331 1.33325 4.31808 1.33325 7.99998C1.33325 11.6819 4.31802 14.6666 7.99992 14.6666Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99992 1.33331C6.28807 3.13075 5.33325 5.51781 5.33325 7.99998C5.33325 10.4822 6.28807 12.8692 7.99992 14.6666C9.71176 12.8692 10.6666 10.4822 10.6666 7.99998C10.6666 5.51781 9.71176 3.13075 7.99992 1.33331Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33325 8H14.6666"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PersonalAdvisoryIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.3334 17.5V15.8333C13.3334 14.9493 12.9822 14.1014 12.3571 13.4763C11.732 12.8512 10.8841 12.5 10.0001 12.5H5.00008C4.11603 12.5 3.26818 12.8512 2.64306 13.4763C2.01794 14.1014 1.66675 14.9493 1.66675 15.8333V17.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.50008 9.16667C9.34103 9.16667 10.8334 7.67428 10.8334 5.83333C10.8334 3.99238 9.34103 2.5 7.50008 2.5C5.65913 2.5 4.16675 3.99238 4.16675 5.83333C4.16675 7.67428 5.65913 9.16667 7.50008 9.16667Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 17.5V15.8333C18.3327 15.0948 18.0869 14.3773 17.6344 13.7936C17.1819 13.2099 16.5484 12.793 15.8333 12.6083"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 2.60834C14.0503 2.79192 14.6858 3.20892 15.1396 3.7936C15.5935 4.37827 15.8398 5.09736 15.8398 5.8375C15.8398 6.57765 15.5935 7.29674 15.1396 7.88141C14.6858 8.46609 14.0503 8.88309 13.3333 9.06667"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 1.33333L9.81867 5.86667L14.6667 6.4L11.3333 9.6L12.364 14.6667L8 12.1333L3.636 14.6667L4.66667 9.6L1.33333 6.4L6.18133 5.86667L8 1.33333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Filled (solid) star for ratings – use with text-warning-500 or similar for color */
export const FilledStarIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 1.33333L9.81867 5.86667L14.6667 6.4L11.3333 9.6L12.364 14.6667L8 12.1333L3.636 14.6667L4.66667 9.6L1.33333 6.4L6.18133 5.86667L8 1.33333Z"
      fill="currentColor"
    />
  </svg>
);

/** Years on platform / achievement icon (advisor profile metrics). Use with text-goals-purple-selected. */
export const YearsOnPlatformIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 26 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.5552 10.7417L18.1757 17.8467C18.1938 17.9304 18.1788 18.0163 18.1325 18.0932C18.0862 18.17 18.011 18.2339 17.9168 18.2765C17.8226 18.3191 17.7139 18.3383 17.6054 18.3315C17.4968 18.3246 17.3935 18.2922 17.3093 18.2384L13.4799 15.9992C13.295 15.8916 13.0704 15.8335 12.8397 15.8335C12.6089 15.8335 12.3844 15.8916 12.1995 15.9992L8.36369 18.2375C8.27953 18.2912 8.17635 18.3237 8.06792 18.3305C7.95949 18.3373 7.85097 18.3182 7.75683 18.2758C7.66269 18.2333 7.58741 18.1695 7.54103 18.0928C7.49465 18.0162 7.47939 17.9303 7.49726 17.8467L9.11673 10.7417"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8359 11.6667C16.3805 11.6667 19.2539 9.42817 19.2539 6.66675C19.2539 3.90532 16.3805 1.66675 12.8359 1.66675C9.29139 1.66675 6.41797 3.90532 6.41797 6.66675C6.41797 9.42817 9.29139 11.6667 12.8359 11.6667Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 4L4 12M4 4L12 12"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.3333 4L6 11.3333L2.66667 8"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExternalLinkIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 2H14V6"
      stroke="#6B7280"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66675 9.33333L14.0001 2"
      stroke="#6B7280"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
      stroke="#6B7280"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IndustryExperienceIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_76_140)">
      <path
        d="M6.6243 10.3332C6.56478 10.1025 6.44453 9.89191 6.27605 9.72343C6.10757 9.55495 5.89702 9.43469 5.6663 9.37517L1.5763 8.32051C1.50652 8.3007 1.44511 8.25867 1.40138 8.2008C1.35765 8.14293 1.33398 8.07238 1.33398 7.99984C1.33398 7.9273 1.35765 7.85675 1.40138 7.79888C1.44511 7.74101 1.50652 7.69898 1.5763 7.67917L5.6663 6.62384C5.89693 6.56438 6.10743 6.44422 6.2759 6.27587C6.44438 6.10751 6.56468 5.8971 6.6243 5.66651L7.67897 1.57651C7.69857 1.50645 7.74056 1.44474 7.79851 1.40077C7.85647 1.35681 7.92722 1.33301 7.99997 1.33301C8.07271 1.33301 8.14346 1.35681 8.20142 1.40077C8.25938 1.44474 8.30136 1.50645 8.32097 1.57651L9.37497 5.66651C9.43449 5.89722 9.55474 6.10777 9.72322 6.27625C9.8917 6.44473 10.1023 6.56499 10.333 6.62451L14.423 7.67851C14.4933 7.69791 14.5553 7.73985 14.5995 7.79789C14.6437 7.85594 14.6677 7.92688 14.6677 7.99984C14.6677 8.0728 14.6437 8.14374 14.5995 8.20179C14.5553 8.25983 14.4933 8.30177 14.423 8.32117L10.333 9.37517C10.1023 9.43469 9.8917 9.55495 9.72322 9.72343C9.55474 9.89191 9.43449 10.1025 9.37497 10.3332L8.3203 14.4232C8.3007 14.4932 8.25871 14.5549 8.20075 14.5989C8.1428 14.6429 8.07205 14.6667 7.9993 14.6667C7.92656 14.6667 7.85581 14.6429 7.79785 14.5989C7.73989 14.5549 7.69791 14.4932 7.6783 14.4232L6.6243 10.3332Z"
        stroke="#4051B5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 2V4.66667"
        stroke="#4051B5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 3.33331H12"
        stroke="#4051B5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66602 11.333V12.6663"
        stroke="#4051B5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 12H2"
        stroke="#4051B5"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_76_140">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HomeIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.5 2.5H3.33333C2.8731 2.5 2.5 2.8731 2.5 3.33333V9.16667C2.5 9.6269 2.8731 10 3.33333 10H7.5C7.96024 10 8.33333 9.6269 8.33333 9.16667V3.33333C8.33333 2.8731 7.96024 2.5 7.5 2.5Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.666 2.5H12.4993C12.0391 2.5 11.666 2.8731 11.666 3.33333V5.83333C11.666 6.29357 12.0391 6.66667 12.4993 6.66667H16.666C17.1263 6.66667 17.4993 6.29357 17.4993 5.83333V3.33333C17.4993 2.8731 17.1263 2.5 16.666 2.5Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.666 10H12.4993C12.0391 10 11.666 10.3731 11.666 10.8333V16.6667C11.666 17.1269 12.0391 17.5 12.4993 17.5H16.666C17.1263 17.5 17.4993 17.1269 17.4993 16.6667V10.8333C17.4993 10.3731 17.1263 10 16.666 10Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 13.3333H3.33333C2.8731 13.3333 2.5 13.7064 2.5 14.1667V16.6667C2.5 17.1269 2.8731 17.5 3.33333 17.5H7.5C7.96024 17.5 8.33333 17.1269 8.33333 16.6667V14.1667C8.33333 13.7064 7.96024 13.3333 7.5 13.3333Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoalsEditIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width={size} height={size} fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9657 1.83432C18.6532 1.5219 18.1467 1.5219 17.8344 1.83432L5.94324 13.7254C5.7993 13.8693 5.68416 14.0394 5.60397 14.2265L3.26466 19.6848C3.1358 19.9856 3.20298 20.3344 3.43429 20.5658C3.6656 20.797 4.01444 20.8642 4.31511 20.7354L9.77351 18.396C9.9606 18.3158 10.1307 18.2006 10.2746 18.0568L22.1657 6.16568C22.478 5.85327 22.478 5.34674 22.1657 5.03432L18.9657 1.83432ZM7.07461 14.8568L18.4 3.53138L20.4686 5.6L9.14324 16.9254L6.75074 17.9507L6.04925 17.2493L7.07461 14.8568Z"
      fill="#1C2024"
    />
  </svg>
);

export const RecordedVideoingIcon = ({
  size = 24,
  className = "",
}: {
  size?: number;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Body */}
    <rect x="3" y="5" width="18" height="14" rx="2" fill="#4A5565" />

    {/* Top clapper */}
    <rect x="3" y="5" width="18" height="4" fill="#D1D5DB" />

    {/* Clapper stripes */}
    <path d="M7 9L9 5H11L9 9H7ZM11 9L13 5H15L13 9H11ZM15 9L17 5H19L17 9H15Z" fill="#4A5565" />

    {/* Play icon */}
    <polygon points="10,11 16,14 10,17" fill="#6B7280" />
  </svg>
);

export const TrophyIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    width={size}
    height={size}
    className={className}
  >
    <path
      d="M208.3 64L432.3 64C458.8 64 480.4 85.8 479.4 112.2C479.2 117.5 479 122.8 478.7 128L528.3 128C554.4 128 577.4 149.6 575.4 177.8C567.9 281.5 514.9 338.5 457.4 368.3C441.6 376.5 425.5 382.6 410.2 387.1C390 415.7 369 430.8 352.3 438.9L352.3 512L416.3 512C434 512 448.3 526.3 448.3 544C448.3 561.7 434 576 416.3 576L224.3 576C206.6 576 192.3 561.7 192.3 544C192.3 526.3 206.6 512 224.3 512L288.3 512L288.3 438.9C272.3 431.2 252.4 416.9 233 390.6C214.6 385.8 194.6 378.5 175.1 367.5C121 337.2 72.2 280.1 65.2 177.6C63.3 149.5 86.2 127.9 112.3 127.9L161.9 127.9C161.6 122.7 161.4 117.5 161.2 112.1C160.2 85.6 181.8 63.9 208.3 63.9zM165.5 176L113.1 176C119.3 260.7 158.2 303.1 198.3 325.6C183.9 288.3 172 239.6 165.5 176zM444 320.8C484.5 297 521.1 254.7 527.3 176L475 176C468.8 236.9 457.6 284.2 444 320.8z"
      fill="currentColor"
    />
  </svg>
);

export const GoalAchievedIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1_523)">
      <path
        d="M9.66779 0.902222H4.33224C3.70102 0.902222 3.18652 1.42149 3.21034 2.05032C3.2151 2.17656 3.21987 2.30281 3.22701 2.42667H0.711681C0.394883 2.42667 0.140015 2.68153 0.140015 2.99833C0.140015 5.20401 0.937966 6.73799 2.00984 7.7789C3.06504 8.80551 4.35129 9.3224 5.29931 9.58441C5.85668 9.73924 6.23779 10.2037 6.23779 10.6706C6.23779 11.1684 5.83286 11.5733 5.33504 11.5733H4.71335C4.29174 11.5733 3.95113 11.914 3.95113 12.3356C3.95113 12.7572 4.29174 13.0978 4.71335 13.0978H9.28668C9.70829 13.0978 10.0489 12.7572 10.0489 12.3356C10.0489 11.914 9.70829 11.5733 9.28668 11.5733H8.66499C8.16717 11.5733 7.76224 11.1684 7.76224 10.6706C7.76224 10.2037 8.14097 9.73685 8.70072 9.58441C9.65112 9.3224 10.9374 8.80551 11.9926 7.7789C13.0621 6.73799 13.86 5.20401 13.86 2.99833C13.86 2.68153 13.6051 2.42667 13.2883 2.42667H10.773C10.7802 2.30281 10.7849 2.17894 10.7897 2.05032C10.8135 1.42149 10.299 0.902222 9.66779 0.902222ZM1.30479 3.57H3.31515C3.5319 5.71613 4.01067 7.15006 4.55138 8.10999C3.95827 7.84797 3.34135 7.47877 2.80779 6.95951C2.04557 6.21872 1.42626 5.14923 1.30717 3.57H1.30479ZM11.1946 6.95951C10.6611 7.47877 10.0441 7.84797 9.45103 8.10999C9.99174 7.15006 10.4705 5.71613 10.6873 3.57H12.6976C12.5761 5.14923 11.9568 6.21872 11.197 6.95951H11.1946Z"
        fill="#FFB900"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_523">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TotalGoalsCompletedIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.9987 14.6666C11.6806 14.6666 14.6654 11.6819 14.6654 7.99998C14.6654 4.31808 11.6806 1.33331 7.9987 1.33331C4.3168 1.33331 1.33203 4.31808 1.33203 7.99998C1.33203 11.6819 4.3168 14.6666 7.9987 14.6666Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.0013 9.33335C8.73768 9.33335 9.33464 8.7364 9.33464 8.00002C9.33464 7.26364 8.73768 6.66669 8.0013 6.66669C7.26492 6.66669 6.66797 7.26364 6.66797 8.00002C6.66797 8.7364 7.26492 9.33335 8.0013 9.33335Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TotalTasksCompletedIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.318 8.59334L11.328 14.2773C11.3393 14.3443 11.3299 14.4131 11.3011 14.4745C11.2723 14.536 11.2253 14.5871 11.1666 14.6212C11.1079 14.6553 11.0402 14.6706 10.9726 14.6651C10.9049 14.6597 10.8405 14.6337 10.788 14.5907L8.40135 12.7993C8.28613 12.7133 8.14617 12.6668 8.00235 12.6668C7.85853 12.6668 7.71857 12.7133 7.60335 12.7993L5.21268 14.59C5.16023 14.633 5.09593 14.6589 5.02835 14.6644C4.96077 14.6698 4.89313 14.6546 4.83446 14.6206C4.77579 14.5866 4.72887 14.5356 4.69996 14.4742C4.67106 14.4129 4.66154 14.3442 4.67268 14.2773L5.68202 8.59334"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9.33333C10.2091 9.33333 12 7.54247 12 5.33333C12 3.12419 10.2091 1.33333 8 1.33333C5.79086 1.33333 4 3.12419 4 5.33333C4 7.54247 5.79086 9.33333 8 9.33333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TotalProgressIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1_240)">
      <path
        d="M14.6654 4.66669L8.9987 10.3334L5.66536 7.00002L1.33203 11.3334"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.668 4.66669H14.668V8.66669"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_240">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AISuggestedGoalIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0 14C0 6.26801 6.26801 0 14 0H34C41.732 0 48 6.26801 48 14V34C48 41.732 41.732 48 34 48H14C6.26801 48 0 41.732 0 34V14Z"
      fill="url(#paint0_linear_54_5072)"
    />
    <path
      d="M21.9369 27.5C21.8477 27.1539 21.6673 26.8381 21.4146 26.5854C21.1618 26.3327 20.846 26.1523 20.4999 26.063L14.3649 24.481C14.2603 24.4513 14.1681 24.3883 14.1026 24.3014C14.037 24.2146 14.0015 24.1088 14.0015 24C14.0015 23.8912 14.037 23.7854 14.1026 23.6986C14.1681 23.6118 14.2603 23.5487 14.3649 23.519L20.4999 21.936C20.8459 21.8468 21.1616 21.6666 21.4143 21.414C21.6671 21.1615 21.8475 20.8459 21.9369 20.5L23.5189 14.365C23.5483 14.2599 23.6113 14.1673 23.6983 14.1014C23.7852 14.0355 23.8913 13.9998 24.0004 13.9998C24.1096 13.9998 24.2157 14.0355 24.3026 14.1014C24.3896 14.1673 24.4525 14.2599 24.4819 14.365L26.0629 20.5C26.1522 20.8461 26.3326 21.1619 26.5853 21.4146C26.838 21.6673 27.1539 21.8477 27.4999 21.937L33.6349 23.518C33.7404 23.5471 33.8335 23.61 33.8998 23.6971C33.9661 23.7841 34.002 23.8906 34.002 24C34.002 24.1094 33.9661 24.2159 33.8998 24.3029C33.8335 24.39 33.7404 24.4529 33.6349 24.482L27.4999 26.063C27.1539 26.1523 26.838 26.3327 26.5853 26.5854C26.3326 26.8381 26.1522 27.1539 26.0629 27.5L24.4809 33.635C24.4515 33.7401 24.3886 33.8327 24.3016 33.8986C24.2147 33.9646 24.1086 34.0003 23.9994 34.0003C23.8903 34.0003 23.7842 33.9646 23.6973 33.8986C23.6103 33.8327 23.5473 33.7401 23.5179 33.635L21.9369 27.5Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 15V19"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34 17H30"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 29V31"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 30H15"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_54_5072"
        x1="0"
        y1="0"
        x2="48"
        y2="48"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AD46FF" />
        <stop offset="1" stopColor="#9810FA" />
      </linearGradient>
    </defs>
  </svg>
);

export const CreateGoalManuallyIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.1741 6.81189C21.7028 6.28332 21.9998 5.56636 21.9999 4.81875C22 4.07113 21.7031 3.3541 21.1746 2.82539C20.646 2.29668 19.929 1.99961 19.1814 1.99951C18.4338 1.99942 17.7168 2.29632 17.1881 2.82489L3.84206 16.1739C3.60988 16.4054 3.43817 16.6904 3.34206 17.0039L2.02106 21.3559C1.99521 21.4424 1.99326 21.5342 2.01541 21.6217C2.03756 21.7092 2.08298 21.7891 2.14685 21.8529C2.21073 21.9167 2.29068 21.962 2.37821 21.984C2.46575 22.006 2.55762 22.0039 2.64406 21.9779L6.99706 20.6579C7.31023 20.5626 7.59523 20.392 7.82706 20.1609L21.1741 6.81189Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoalNotesIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.925 15C7.35643 15.7343 9.00306 15.9332 10.5682 15.5609C12.1333 15.1885 13.5139 14.2694 14.4613 12.9692C15.4087 11.6689 15.8606 10.0731 15.7354 8.46916C15.6103 6.86524 14.9164 5.35876 13.7789 4.22118C12.6413 3.0836 11.1348 2.38972 9.53088 2.2646C7.92697 2.13947 6.3311 2.59132 5.03086 3.53872C3.73063 4.48612 2.81152 5.86677 2.43917 7.43187C2.06682 8.99697 2.26571 10.6436 3 12.075L1.5 16.5L5.925 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoalsCelebrationIcon = ({ className, size = 144 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g opacity="0.963698">
      <mask id="path-1-inside-1_96_17011" fill="white">
        <path d="M0 72C0 32.2355 32.2355 0 72 0C111.765 0 144 32.2355 144 72C144 111.765 111.765 144 72 144C32.2355 144 0 111.765 0 72Z" />
      </mask>
      <path
        d="M0 72C0 32.2355 32.2355 0 72 0C111.765 0 144 32.2355 144 72C144 111.765 111.765 144 72 144C32.2355 144 0 111.765 0 72Z"
        fill="url(#paint0_linear_96_17011)"
      />
      <path
        d="M72 144V140C34.4446 140 4 109.555 4 72H0H-4C-4 113.974 30.0264 148 72 148V144ZM144 72H140C140 109.555 109.555 140 72 140V144V148C113.974 148 148 113.974 148 72H144ZM72 0V4C109.555 4 140 34.4446 140 72H144H148C148 30.0264 113.974 -4 72 -4V0ZM72 0V-4C30.0264 -4 -4 30.0264 -4 72H0H4C4 34.4446 34.4446 4 72 4V0Z"
        fill="#C27AFF"
        mask="url(#path-1-inside-1_96_17011)"
      />
      <path
        d="M65.811 82.4998C65.5432 81.4616 65.002 80.5141 64.2439 79.7559C63.4857 78.9978 62.5382 78.4566 61.5 78.1888L43.095 73.4428C42.781 73.3536 42.5046 73.1645 42.3078 72.9041C42.1111 72.6437 42.0046 72.3262 42.0046 71.9998C42.0046 71.6734 42.1111 71.3559 42.3078 71.0954C42.5046 70.835 42.781 70.6459 43.095 70.5568L61.5 65.8078C62.5379 65.5402 63.4851 64.9995 64.2432 64.2419C65.0013 63.4843 65.5427 62.5374 65.811 61.4998L70.557 43.0948C70.6452 42.7795 70.8342 42.5018 71.095 42.304C71.3558 42.1061 71.6741 41.999 72.0015 41.999C72.3289 41.999 72.6472 42.1061 72.908 42.304C73.1688 42.5018 73.3578 42.7795 73.446 43.0948L78.189 61.4998C78.4568 62.538 78.998 63.4855 79.7562 64.2436C80.5143 65.0018 81.4618 65.5429 82.5 65.8108L100.905 70.5538C101.222 70.6411 101.501 70.8298 101.7 71.091C101.898 71.3522 102.006 71.6715 102.006 71.9998C102.006 72.3281 101.898 72.6473 101.7 72.9085C101.501 73.1697 101.222 73.3585 100.905 73.4458L82.5 78.1888C81.4618 78.4566 80.5143 78.9978 79.7562 79.7559C78.998 80.5141 78.4568 81.4616 78.189 82.4998L73.443 100.905C73.3548 101.22 73.1659 101.498 72.905 101.696C72.6442 101.893 72.3259 102.001 71.9985 102.001C71.6711 102.001 71.3528 101.893 71.092 101.696C70.8312 101.498 70.6422 101.22 70.554 100.905L65.811 82.4998Z"
        stroke="#9810FA"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M96 45V57"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102 51H90"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48 87V93"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51 90H45"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.322853">
        <path
          d="M62.2862 88.4802C61.8658 86.8507 61.0165 85.3636 59.8265 84.1736C58.6366 82.9837 57.1495 82.1343 55.52 81.7139L26.6328 74.265C26.1399 74.1251 25.7062 73.8283 25.3973 73.4195C25.0884 73.0108 24.9213 72.5124 24.9213 72.0001C24.9213 71.4878 25.0884 70.9895 25.3973 70.5808C25.7062 70.172 26.1399 69.8752 26.6328 69.7353L55.52 62.2816C57.1489 61.8616 58.6356 61.013 59.8255 59.8239C61.0154 58.6348 61.8651 57.1487 62.2862 55.5201L69.7352 26.6329C69.8737 26.1381 70.1702 25.7022 70.5795 25.3917C70.9889 25.0812 71.4886 24.9131 72.0024 24.9131C72.5162 24.9131 73.0159 25.0812 73.4252 25.3917C73.8346 25.7022 74.1311 26.1381 74.2696 26.6329L81.7138 55.5201C82.1342 57.1496 82.9836 58.6367 84.1735 59.8266C85.3635 61.0166 86.8506 61.8659 88.4801 62.2863L117.367 69.7306C117.864 69.8676 118.302 70.1638 118.614 70.5738C118.926 70.9838 119.096 71.4848 119.096 72.0001C119.096 72.5154 118.926 73.0165 118.614 73.4265C118.302 73.8364 117.864 74.1327 117.367 74.2697L88.4801 81.7139C86.8506 82.1343 85.3635 82.9837 84.1735 84.1736C82.9836 85.3636 82.1342 86.8507 81.7138 88.4802L74.2648 117.367C74.1264 117.862 73.8299 118.298 73.4205 118.609C73.0112 118.919 72.5115 119.087 71.9977 119.087C71.4839 119.087 70.9842 118.919 70.5748 118.609C70.1655 118.298 69.8689 117.862 69.7305 117.367L62.2862 88.4802Z"
          stroke="#AD46FF"
          strokeWidth="4.70859"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M109.669 29.623V48.4574"
          stroke="currentColor"
          strokeWidth="4.70859"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M119.086 39.04H100.252"
          stroke="currentColor"
          strokeWidth="4.70859"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.3313 95.543V104.96"
          stroke="currentColor"
          strokeWidth="4.70859"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.0399 100.251H29.6227"
          stroke="currentColor"
          strokeWidth="4.70859"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_96_17011"
        x1="0"
        y1="0"
        x2="144"
        y2="144"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3E8FF" />
        <stop offset="1" stopColor="#FCE7F3" />
      </linearGradient>
    </defs>
  </svg>
);

export const GoalsCelebrationSharePABIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.3334 17.5V15.8333C13.3334 14.9493 12.9822 14.1014 12.357 13.4763C11.7319 12.8512 10.8841 12.5 10 12.5H5.00002C4.11597 12.5 3.26812 12.8512 2.643 13.4763C2.01788 14.1014 1.66669 14.9493 1.66669 15.8333V17.5"
      stroke="currentColor"
      strokeWidth="2.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.50002 9.16667C9.34097 9.16667 10.8334 7.67428 10.8334 5.83333C10.8334 3.99238 9.34097 2.5 7.50002 2.5C5.65907 2.5 4.16669 3.99238 4.16669 5.83333C4.16669 7.67428 5.65907 9.16667 7.50002 9.16667Z"
      stroke="currentColor"
      strokeWidth="2.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 17.5001V15.8334C18.3328 15.0948 18.0869 14.3774 17.6345 13.7937C17.182 13.2099 16.5484 12.793 15.8333 12.6084"
      stroke="currentColor"
      strokeWidth="2.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 2.6084C14.0503 2.79198 14.6858 3.20898 15.1397 3.79366C15.5935 4.37833 15.8398 5.09742 15.8398 5.83757C15.8398 6.57771 15.5935 7.2968 15.1397 7.88147C14.6858 8.46615 14.0503 8.88315 13.3333 9.06673"
      stroke="currentColor"
      strokeWidth="2.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TwitterIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_96_17054)">
      <path
        d="M16.5 3.00002C16.5 3.00002 15.975 4.57502 15 5.55002C16.2 13.05 7.95 18.525 1.5 14.25C3.15 14.325 4.8 13.8 6 12.75C2.25 11.625 0.375 7.20002 2.25 3.75002C3.9 5.70002 6.45 6.82502 9 6.75002C8.325 3.60002 12 1.80002 14.25 3.90002C15.075 3.90002 16.5 3.00002 16.5 3.00002Z"
        stroke="#0069A8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_96_17054">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CopyLinkIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_96_17058)">
      <path
        d="M7.5 9.74997C7.82209 10.1806 8.23302 10.5369 8.70491 10.7947C9.17681 11.0525 9.69863 11.2058 10.235 11.2442C10.7713 11.2826 11.3097 11.2052 11.8135 11.0173C12.3173 10.8294 12.7748 10.5353 13.155 10.155L15.405 7.90497C16.0881 7.19772 16.4661 6.25046 16.4575 5.26722C16.449 4.28398 16.0546 3.34343 15.3593 2.64815C14.664 1.95287 13.7235 1.55849 12.7403 1.54995C11.757 1.5414 10.8098 1.91938 10.1025 2.60247L8.8125 3.88497"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 8.24992C10.1779 7.81933 9.76701 7.46304 9.29511 7.20522C8.82322 6.9474 8.3014 6.79409 7.76504 6.75567C7.22868 6.71726 6.69034 6.79465 6.18652 6.98259C5.6827 7.17053 5.22519 7.46462 4.84503 7.84492L2.59503 10.0949C1.91194 10.8022 1.53396 11.7494 1.5425 12.7327C1.55104 13.7159 1.94543 14.6565 2.64071 15.3517C3.33599 16.047 4.27654 16.4414 5.25977 16.45C6.24301 16.4585 7.19027 16.0805 7.89753 15.3974L9.18003 14.1149"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_96_17058">
        <rect width={size} height={size} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ShareIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.5 6C14.7426 6 15.75 4.99264 15.75 3.75C15.75 2.50736 14.7426 1.5 13.5 1.5C12.2574 1.5 11.25 2.50736 11.25 3.75C11.25 4.99264 12.2574 6 13.5 6Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 11.25C5.74264 11.25 6.75 10.2426 6.75 9C6.75 7.75736 5.74264 6.75 4.5 6.75C3.25736 6.75 2.25 7.75736 2.25 9C2.25 10.2426 3.25736 11.25 4.5 11.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 16.5C14.7426 16.5 15.75 15.4926 15.75 14.25C15.75 13.0074 14.7426 12 13.5 12C12.2574 12 11.25 13.0074 11.25 14.25C11.25 15.4926 12.2574 16.5 13.5 16.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.4425 10.1323L11.565 13.1173"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5575 4.88232L6.4425 7.86732"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AttachmentIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.82269 13.5013L14 8.19995"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6666 3.99996L5.05731 9.72396C4.80734 9.974 4.66692 10.3131 4.66692 10.6666C4.66692 11.0202 4.80734 11.3593 5.05731 11.6093C5.30734 11.8593 5.64642 11.9997 5.99997 11.9997C6.35353 11.9997 6.6926 11.8593 6.94264 11.6093L12.552 5.88529C13.0519 5.38522 13.3327 4.70706 13.3327 3.99996C13.3327 3.29286 13.0519 2.6147 12.552 2.11463C12.0519 1.6147 11.3737 1.33386 10.6666 1.33386C9.95954 1.33386 9.28138 1.6147 8.78131 2.11463L3.17131 7.83796C2.4211 8.58817 1.99963 9.60567 1.99963 10.6666C1.99963 11.7276 2.4211 12.7451 3.17131 13.4953C3.92151 14.2455 4.93902 14.667 5.99997 14.667C7.06093 14.667 8.07843 14.2455 8.82864 13.4953"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SendMessageIcon = ({ className, size = 18 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.902 16.2644C10.9305 16.3354 10.98 16.396 11.0439 16.4381C11.1079 16.4801 11.1831 16.5016 11.2596 16.4997C11.3361 16.4977 11.4102 16.4724 11.4718 16.4271C11.5335 16.3818 11.5799 16.3188 11.6047 16.2464L16.4797 1.99642C16.5037 1.92997 16.5083 1.85805 16.4929 1.78909C16.4776 1.72012 16.4429 1.65697 16.3929 1.607C16.3429 1.55704 16.2798 1.52234 16.2108 1.50696C16.1418 1.49159 16.0699 1.49617 16.0035 1.52017L1.75348 6.39517C1.6811 6.41999 1.61805 6.46636 1.57278 6.52805C1.52751 6.58974 1.5022 6.6638 1.50025 6.74029C1.49829 6.81678 1.51977 6.89204 1.56182 6.95597C1.60387 7.01989 1.66446 7.06943 1.73548 7.09792L7.68298 9.48292C7.87099 9.5582 8.04182 9.67077 8.18515 9.81384C8.32849 9.95692 8.44136 10.1275 8.51698 10.3154L10.902 16.2644Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3905 1.61035L8.18555 9.8146"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6665 6.66663L7.99984 9.99996L11.3332 6.66663"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10V2"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const KebabMenuIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.9987 8.66665C8.36689 8.66665 8.66536 8.36817 8.66536 7.99998C8.66536 7.63179 8.36689 7.33331 7.9987 7.33331C7.63051 7.33331 7.33203 7.63179 7.33203 7.99998C7.33203 8.36817 7.63051 8.66665 7.9987 8.66665Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9987 4.00002C8.36689 4.00002 8.66536 3.70154 8.66536 3.33335C8.66536 2.96516 8.36689 2.66669 7.9987 2.66669C7.63051 2.66669 7.33203 2.96516 7.33203 3.33335C7.33203 3.70154 7.63051 4.00002 7.9987 4.00002Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9987 13.3333C8.36689 13.3333 8.66536 13.0349 8.66536 12.6667C8.66536 12.2985 8.36689 12 7.9987 12C7.63051 12 7.33203 12.2985 7.33203 12.6667C7.33203 13.0349 7.63051 13.3333 7.9987 13.3333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AdvisorPersonalPABIcon = ({ className, size = 24 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AdvisorPABOKTsStatusIcon = ({ className, size = 12 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.5 8.5L2.5 9.5L4.5 7.5"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 3.5L2.5 4.5L4.5 2.5"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 3H10.5"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 6H10.5"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 9H10.5"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ViewPABDetailsIcon = ({ className, size = 12 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_2037_870)">
      <path
        d="M1.37468 8.232C1.31912 8.08232 1.31912 7.91767 1.37468 7.768C1.91581 6.4559 2.83435 5.33402 4.01386 4.5446C5.19336 3.75517 6.58071 3.33374 8.00001 3.33374C9.41932 3.33374 10.8067 3.75517 11.9862 4.5446C13.1657 5.33402 14.0842 6.4559 14.6253 7.768C14.6809 7.91767 14.6809 8.08232 14.6253 8.232C14.0842 9.54409 13.1657 10.666 11.9862 11.4554C10.8067 12.2448 9.41932 12.6663 8.00001 12.6663C6.58071 12.6663 5.19336 12.2448 4.01386 11.4554C2.83435 10.666 1.91581 9.54409 1.37468 8.232Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2037_870">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CureArrowIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.6668 4.66667L9.00016 10.3333L5.66683 7L1.3335 11.3333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6665 4.66667H14.6665V8.66667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OneOnOneCallIcon = ({ className, size = 10 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.6665 5.41667L8.84275 6.8675C8.87413 6.88838 8.91057 6.90035 8.94822 6.90215C8.98586 6.90395 9.02328 6.89551 9.0565 6.87772C9.08973 6.85994 9.1175 6.83347 9.13687 6.80115C9.15624 6.76882 9.16648 6.73185 9.1665 6.69417V3.27917C9.16651 3.24251 9.15685 3.2065 9.1385 3.17477C9.12014 3.14304 9.09373 3.11672 9.06195 3.09846C9.03016 3.0802 8.99412 3.07065 8.95746 3.07077C8.92081 3.0709 8.88483 3.08069 8.85317 3.09917L6.6665 4.375"
      stroke="currentColor"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8335 2.5H1.66683C1.20659 2.5 0.833496 2.8731 0.833496 3.33333V6.66667C0.833496 7.1269 1.20659 7.5 1.66683 7.5H5.8335C6.29373 7.5 6.66683 7.1269 6.66683 6.66667V3.33333C6.66683 2.8731 6.29373 2.5 5.8335 2.5Z"
      stroke="currentColor"
      strokeWidth="0.833333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GiftIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.6667 4.66699H2.33333C2.01117 4.66699 1.75 4.92816 1.75 5.25033V6.41699C1.75 6.73916 2.01117 7.00033 2.33333 7.00033H11.6667C11.9888 7.00033 12.25 6.73916 12.25 6.41699V5.25033C12.25 4.92816 11.9888 4.66699 11.6667 4.66699Z"
      stroke="#D97706"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 4.66699V12.2503"
      stroke="#D97706"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0833 7V11.0833C11.0833 11.3928 10.9604 11.6895 10.7416 11.9083C10.5228 12.1271 10.226 12.25 9.91663 12.25H4.08329C3.77387 12.25 3.47713 12.1271 3.25833 11.9083C3.03954 11.6895 2.91663 11.3928 2.91663 11.0833V7"
      stroke="#D97706"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.37484 4.66692C3.98806 4.66692 3.61713 4.51328 3.34364 4.23979C3.07015 3.9663 2.9165 3.59536 2.9165 3.20859C2.9165 2.82181 3.07015 2.45088 3.34364 2.17739C3.61713 1.9039 3.98806 1.75026 4.37484 1.75026C4.93757 1.74045 5.48902 2.01349 5.95727 2.53377C6.42551 3.05404 6.78883 3.79741 6.99984 4.66692C7.21084 3.79741 7.57416 3.05404 8.04241 2.53377C8.51066 2.01349 9.0621 1.74045 9.62484 1.75026C10.0116 1.75026 10.3825 1.9039 10.656 2.17739C10.9295 2.45088 11.0832 2.82181 11.0832 3.20859C11.0832 3.59536 10.9295 3.9663 10.656 4.23979C10.3825 4.51328 10.0116 4.66692 9.62484 4.66692"
      stroke="#D97706"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlatformTourIcon = ({ className, size = 11 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 9 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0.541626 0.541656L8.12496 5.41666L0.541626 10.2917V0.541656Z"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StepCompletedIcon = ({ className, size = 24 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10.9" fill="currentColor" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M7.5 12L10.5 15L16.5 9"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AgreeAndSignOffIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.99992 14.6666C11.6818 14.6666 14.6666 11.6819 14.6666 7.99998C14.6666 4.31808 11.6818 1.33331 7.99992 1.33331C4.31802 1.33331 1.33325 4.31808 1.33325 7.99998C1.33325 11.6819 4.31802 14.6666 7.99992 14.6666Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 8.00002L7.33333 9.33335L10 6.66669"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StartTourIcon = ({ className }: { className?: string } = {}) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.25 1.625L10.8333 6.5L3.25 11.375V1.625Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PGWhatHappensNextIcon = ({ className, size = 18 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6 1.5V4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 1.5V4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 3H3.75C2.92157 3 2.25 3.67157 2.25 4.5V15C2.25 15.8284 2.92157 16.5 3.75 16.5H14.25C15.0784 16.5 15.75 15.8284 15.75 15V4.5C15.75 3.67157 15.0784 3 14.25 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 7.5H15.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 12L8.25 13.5L11.25 10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PGWhatToExpectIcon = ({ className, size = 18 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.375 12.375C2.25 13.32 1.875 16.125 1.875 16.125C1.875 16.125 4.68 15.75 5.625 14.625C6.1575 13.995 6.15 13.0275 5.5575 12.4425C5.26598 12.1643 4.88197 12.0035 4.47917 11.991C4.07637 11.9786 3.68316 12.1153 3.375 12.375Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.2499L6.75 8.99994C7.14911 7.96451 7.65165 6.97199 8.25 6.03744C9.12389 4.64018 10.3407 3.48973 11.7848 2.69551C13.2288 1.90129 14.852 1.48972 16.5 1.49994C16.5 3.53994 15.915 7.12494 12 9.74994C11.0527 10.349 10.0476 10.8515 9 11.2499Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 8.99989H3C3 8.99989 3.4125 6.72739 4.5 5.99989C5.715 5.18989 8.25 5.99989 8.25 5.99989"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.25V15C9 15 11.2725 14.5875 12 13.5C12.81 12.285 12 9.75 12 9.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PGHowtoShowUPIcon = ({ className, size = 18 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.25 1.5H6.75C6.33579 1.5 6 1.83579 6 2.25V3.75C6 4.16421 6.33579 4.5 6.75 4.5H11.25C11.6642 4.5 12 4.16421 12 3.75V2.25C12 1.83579 11.6642 1.5 11.25 1.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3H13.5C13.8978 3 14.2794 3.15804 14.5607 3.43934C14.842 3.72064 15 4.10218 15 4.5V15C15 15.3978 14.842 15.7794 14.5607 16.0607C14.2794 16.342 13.8978 16.5 13.5 16.5H4.5C4.10218 16.5 3.72064 16.342 3.43934 16.0607C3.15804 15.7794 3 15.3978 3 15V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 8.25H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 8.25H6.0075"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 12H6.0075"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PGSessionNormsIcon = ({ className, size = 18 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.25 12.75L9.75 14.25C9.89774 14.3977 10.0731 14.5149 10.2662 14.5949C10.4592 14.6748 10.6661 14.716 10.875 14.716C11.0839 14.716 11.2908 14.6748 11.4838 14.5949C11.6769 14.5149 11.8523 14.3977 12 14.25C12.1477 14.1023 12.2649 13.9269 12.3449 13.7338C12.4248 13.5408 12.466 13.3339 12.466 13.125C12.466 12.9161 12.4248 12.7092 12.3449 12.5162C12.2649 12.3231 12.1477 12.1477 12 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 10.4999L12.375 12.3749C12.6734 12.6733 13.0781 12.8409 13.5 12.8409C13.922 12.8409 14.3267 12.6733 14.625 12.3749C14.9234 12.0765 15.091 11.6718 15.091 11.2499C15.091 10.8279 14.9234 10.4233 14.625 10.1249L11.715 7.21489C11.2932 6.79354 10.7213 6.55687 10.125 6.55687C9.5288 6.55687 8.95692 6.79354 8.53505 7.21489L7.87505 7.87489C7.57668 8.17326 7.172 8.34088 6.75005 8.34088C6.32809 8.34088 5.92342 8.17326 5.62505 7.87489C5.32668 7.57652 5.15906 7.17185 5.15906 6.74989C5.15906 6.32793 5.32668 5.92326 5.62505 5.62489L7.73255 3.51739C8.41673 2.835 9.30897 2.4003 10.268 2.28212C11.2271 2.16393 12.1982 2.36901 13.0275 2.86489L13.38 3.07489C13.6994 3.26763 14.0791 3.33448 14.445 3.26239L15.75 2.99989"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 2.25L16.5 10.5H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 2.25L1.5 10.5L6.375 15.375C6.67337 15.6734 7.07804 15.841 7.5 15.841C7.92196 15.841 8.32663 15.6734 8.625 15.375C8.92337 15.0766 9.09099 14.672 9.09099 14.25C9.09099 13.828 8.92337 13.4234 8.625 13.125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 3H8.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PGPacingYourPABJourneyIcon = ({ className, size = 18 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.5 5.25L10.125 11.625L6.375 7.875L1.5 12.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.25H16.5V9.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FTUXIcon = ({ className, size = 77 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 74 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_dd_1216_2536)">
      <path
        d="M12 18C12 9.16344 19.1634 2 28 2H46C54.8366 2 62 9.16344 62 18V36C62 44.8366 54.8366 52 46 52H28C19.1634 52 12 44.8366 12 36V18Z"
        fill="url(#paint0_linear_1216_2536)"
        shapeRendering="crispEdges"
      />
      <g filter="url(#filter1_dd_1216_2536)">
        <g clipPath="url(#clip0_1216_2536)">
          <path
            d="M35.2809 29.9167C35.2065 29.6283 35.0561 29.3651 34.8455 29.1545C34.6349 28.9439 34.3718 28.7936 34.0834 28.7192L28.9709 27.4009C28.8836 27.3761 28.8069 27.3236 28.7522 27.2512C28.6975 27.1789 28.668 27.0907 28.668 27C28.668 26.9094 28.6975 26.8212 28.7522 26.7488C28.8069 26.6765 28.8836 26.624 28.9709 26.5992L34.0834 25.28C34.3717 25.2057 34.6348 25.0555 34.8454 24.8451C35.056 24.6346 35.2063 24.3716 35.2809 24.0834L36.5992 18.9709C36.6237 18.8833 36.6762 18.8062 36.7486 18.7512C36.8211 18.6963 36.9095 18.6665 37.0004 18.6665C37.0914 18.6665 37.1798 18.6963 37.2523 18.7512C37.3247 18.8062 37.3772 18.8833 37.4017 18.9709L38.7192 24.0834C38.7936 24.3718 38.9439 24.635 39.1545 24.8456C39.3651 25.0562 39.6283 25.2065 39.9167 25.2809L45.0292 26.5984C45.1171 26.6226 45.1946 26.6751 45.2499 26.7476C45.3052 26.8202 45.3351 26.9088 45.3351 27C45.3351 27.0912 45.3052 27.1799 45.2499 27.2525C45.1946 27.325 45.1171 27.3775 45.0292 27.4017L39.9167 28.7192C39.6283 28.7936 39.3651 28.9439 39.1545 29.1545C38.9439 29.3651 38.7936 29.6283 38.7192 29.9167L37.4009 35.0292C37.3764 35.1168 37.3239 35.1939 37.2514 35.2489C37.179 35.3038 37.0905 35.3336 36.9996 35.3336C36.9087 35.3336 36.8202 35.3038 36.7478 35.2489C36.6754 35.1939 36.6229 35.1168 36.5984 35.0292L35.2809 29.9167Z"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M43.668 19.5V22.8333"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.3333 21.1666H42"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.332 31.1665V32.8332"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.1667 32H29.5"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_1216_2536"
        x="0"
        y="0"
        width="74"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_1216_2536"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1216_2536" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="3"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_1216_2536"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1216_2536"
          result="effect2_dropShadow_1216_2536"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1216_2536"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_1216_2536"
        x="-5"
        y="5"
        width="84"
        height="84"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="6"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_1216_2536"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.382176 0 0 0 0 0.371888 0 0 0 0 1 0 0 0 0.2 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1216_2536" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="5"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_1216_2536"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.382176 0 0 0 0 0.371888 0 0 0 0 1 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1216_2536"
          result="effect2_dropShadow_1216_2536"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1216_2536"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1216_2536"
        x1="12"
        y1="2"
        x2="62"
        y2="52"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#615FFF" />
        <stop offset="1" stopColor="#AD46FF" />
      </linearGradient>
      <clipPath id="clip0_1216_2536">
        <rect width="20" height="20" fill="white" transform="translate(27 17)" />
      </clipPath>
    </defs>
  </svg>
);

export const PABScheduledIcon = ({ className, size = 80 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_dd_1322_7586)">
      <path
        d="M15 21C15 12.1634 22.1634 5 31 5H49C57.8366 5 65 12.1634 65 21V39C65 47.8366 57.8366 55 49 55H31C22.1634 55 15 47.8366 15 39V21Z"
        fill="url(#paint0_linear_1322_7586)"
        shapeRendering="crispEdges"
      />
      <path
        d="M33.8 29.3L30 40L40.7 36.21"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 21H32.0083"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 26H50.0083"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43 20H43.0083"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 38H50.0083"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 20L47.76 20.75C47.1224 20.9624 46.5783 21.3896 46.2208 21.9587C45.8633 22.5278 45.7146 23.2034 45.8 23.87C45.9 24.73 45.23 25.5 44.35 25.5H43.97C43.11 25.5 42.37 26.1 42.21 26.94L42 28"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 31.0001L49.18 30.6701C48.32 30.3301 47.36 30.8701 47.2 31.7801C47.09 32.4801 46.48 33.0001 45.77 33.0001H45"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39 20L39.33 20.82C39.67 21.68 39.13 22.64 38.22 22.8C37.52 22.9 37 23.52 37 24.23V25"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39 31C40.93 32.93 41.83 35.17 41 36C40.17 36.83 37.93 35.93 36 34C34.07 32.07 33.17 29.83 34 29C34.83 28.17 37.07 29.07 39 31Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1322_7586"
        x="0"
        y="0"
        width="80"
        height="80"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.737255 0 0 0 0 0.490196 0 0 0 0.2 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1322_7586" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0.737255 0 0 0 0 0.490196 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1322_7586"
          result="effect2_dropShadow_1322_7586"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1322_7586"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1322_7586"
        x1="15"
        y1="5"
        x2="65"
        y2="55"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00BC7D" />
        <stop offset="1" stopColor="#00BBA7" />
      </linearGradient>
    </defs>
  </svg>
);

export const StarsTabIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.77103 1.07875C8.80755 1.00497 8.86397 0.942863 8.93391 0.89944C9.00385 0.856018 9.08454 0.833008 9.16686 0.833008C9.24919 0.833008 9.32988 0.856018 9.39982 0.89944C9.46976 0.942863 9.52618 1.00497 9.5627 1.07875L11.4877 4.97792C11.6145 5.23456 11.8017 5.45659 12.0332 5.62496C12.2647 5.79333 12.5336 5.90301 12.8169 5.94459L17.1219 6.57459C17.2034 6.5864 17.2801 6.62081 17.3431 6.67392C17.4061 6.72702 17.4531 6.79671 17.4785 6.87509C17.504 6.95347 17.5071 7.03742 17.4874 7.11745C17.4676 7.19747 17.4259 7.27038 17.3669 7.32792L14.2535 10.3596C14.0482 10.5597 13.8946 10.8067 13.8059 11.0793C13.7172 11.3519 13.6961 11.642 13.7444 11.9246L14.4794 16.2079C14.4938 16.2895 14.485 16.3734 14.4539 16.4502C14.4229 16.5269 14.371 16.5934 14.304 16.6421C14.237 16.6907 14.1577 16.7196 14.0751 16.7253C13.9925 16.7311 13.9099 16.7135 13.8369 16.6746L9.98853 14.6513C9.73496 14.5181 9.45285 14.4485 9.16645 14.4485C8.88005 14.4485 8.59793 14.5181 8.34436 14.6513L4.49686 16.6746C4.42381 16.7133 4.34136 16.7307 4.25891 16.7248C4.17645 16.7189 4.0973 16.6901 4.03044 16.6414C3.96359 16.5928 3.91173 16.5264 3.88074 16.4498C3.84976 16.3731 3.84091 16.2893 3.8552 16.2079L4.58936 11.9254C4.63786 11.6427 4.61685 11.3524 4.52815 11.0796C4.43944 10.8068 4.2857 10.5597 4.0802 10.3596L0.966864 7.32875C0.907359 7.27128 0.865192 7.19825 0.845166 7.11798C0.825141 7.03771 0.828062 6.95343 0.853597 6.87474C0.879132 6.79606 0.926254 6.72612 0.989595 6.67291C1.05294 6.61969 1.12995 6.58533 1.21186 6.57375L5.51603 5.94459C5.79958 5.90334 6.06886 5.7938 6.30068 5.62541C6.53251 5.45702 6.71995 5.23481 6.84686 4.97792L8.77103 1.07875Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarEmptyStateIcon = ({ className, size = 181 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 151 181"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={className}
  >
    <g filter="url(#filter0_d_1773_381)">
      <mask
        id="mask0_1773_381"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="83"
        y="29"
        width="62"
        height="66"
      >
        <path
          d="M143.036 59.2926L118.847 90.8581C116.084 94.4637 110.979 95.136 107.384 92.3076L87.0926 76.3441C83.5584 73.5636 82.8749 68.3371 85.6379 64.7315L109.827 33.166C112.59 29.5604 117.757 28.9361 121.291 31.7166L141.582 47.6801C145.178 50.5084 145.799 55.687 143.036 59.2926Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1773_381)">
        <rect
          x="83.9258"
          y="29.9678"
          width="60.9452"
          height="64.0965"
          fill="url(#pattern0_1773_381)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.755 70.6605C115.615 70.9709 115.449 71.0597 115.144 70.82L112.402 68.6627C112.281 68.5669 112.189 68.4309 112.124 68.2609C112.063 68.0852 112.072 67.9462 112.099 67.7842L115.26 59.07L109.599 66.4573L109.757 66.1243C109.613 66.3125 109.355 66.2654 109.172 66.1216L106.43 63.9644C106.187 63.7726 106.109 63.4924 106.31 63.23L120.999 44.0625C121.204 43.7944 121.487 43.8065 121.731 43.9983L126.301 47.5937C126.849 48.0251 127.267 48.4999 127.606 49.0774C127.888 49.6012 128.118 50.1935 128.234 50.8063C128.294 51.3655 128.306 51.9878 128.152 52.5708C128.064 53.1961 127.766 53.712 127.386 54.2083L123.823 58.8575C123.286 59.5591 122.617 60.0482 121.823 60.3196C120.968 60.5431 120.149 60.5933 119.303 60.422L115.755 70.6605ZM118.167 55.2762L119.143 56.0435C119.325 56.1873 119.56 56.2628 119.783 56.2275C120.071 56.2344 120.254 56.1223 120.398 55.934L123.742 51.5701C123.891 51.3761 123.953 51.1687 123.87 50.8936C123.853 50.6608 123.719 50.4543 123.536 50.3105L122.561 49.5432L118.167 55.2762Z"
        fill="white"
      />
      <mask
        id="mask1_1773_381"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="59"
        y="6"
        width="59"
        height="75"
      >
        <path
          d="M117.317 25.9718L99.6345 75.3449C98.0976 79.6361 93.443 81.8637 89.1644 80.2905L65.0158 71.4115C60.8097 69.865 58.575 65.1042 60.1119 60.813L77.7946 11.4399C79.3315 7.14867 84.0594 4.948 88.2655 6.49451L112.414 15.3736C116.693 16.9467 118.854 21.6805 117.317 25.9718Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1773_381)">
        <rect
          width="58.7912"
          height="74.8395"
          transform="matrix(0.997272 -1.49391e-06 -9.21939e-07 1.00268 59.6445 6)"
          fill="url(#pattern1_1773_381)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.7831 44.4221C94.7437 44.7611 94.5407 44.8706 94.1781 44.7373L90.9148 43.5374C90.5522 43.4041 90.4656 43.188 90.5049 42.8491L91.5276 39.0759L89.2798 38.2495L87.6764 41.8091C87.5645 42.1214 87.2886 42.2041 86.9985 42.0974L83.6629 40.871C83.3728 40.7643 83.2864 40.5484 83.3982 40.2361L94.3236 18.4378C94.4379 18.1187 94.7113 18.0423 95.0739 18.1757L99.8598 19.9354C100.15 20.042 100.312 20.2785 100.27 20.6243L94.7831 44.4221ZM92.5995 35.1678L95.2413 25.7283L94.9509 25.6215L90.931 34.5543L92.5995 35.1678Z"
        fill="white"
      />
      <mask
        id="mask2_1773_381"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="37"
        y="9"
        width="49"
        height="58"
      >
        <path
          d="M79.3279 16.507L85.1122 53.2158C85.8211 57.7144 82.8177 61.9546 78.3231 62.6817L52.955 66.7855C48.5365 67.5003 44.3025 64.4309 43.5936 59.9323L37.8093 23.2236C37.1004 18.725 40.1806 14.4719 44.5991 13.7571L69.9672 9.65324C74.4618 8.92613 78.619 12.0085 79.3279 16.507Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_1773_381)">
        <rect
          x="37.7109"
          y="9.55273"
          width="47.8304"
          height="57.8432"
          fill="url(#pattern2_1773_381)"
        />
      </g>
      <path
        d="M63.5329 19.4528C63.9138 19.3912 64.0915 19.5308 64.1443 19.866L64.6443 23.0395C64.696 23.3676 64.5713 23.5634 64.1904 23.6251L61.524 24.0564L64.7213 44.347C64.773 44.6751 64.5712 44.883 64.2665 44.9323L60.8384 45.4869C60.7622 45.4992 60.6017 45.4742 60.5109 45.3938C60.3428 45.3186 60.2488 45.2168 60.2263 45.0742L57.0291 24.7836L54.3627 25.2149C54.058 25.2642 53.8023 25.1299 53.7506 24.8018L53.2506 21.6283C53.1977 21.2931 53.4006 21.0919 53.7053 21.0426L63.5329 19.4528Z"
        fill="white"
      />
      <mask
        id="mask3_1773_381"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="22"
        width="68"
        height="78"
      >
        <path
          d="M43.0697 26.7801L70.8315 72.8875C73.175 76.7796 71.9839 81.855 68.0983 84.2568L46.168 97.8131C42.3483 100.174 37.2827 98.9664 34.9393 95.0743L7.17746 48.9669C4.834 45.0748 6.09123 39.9578 9.91095 37.5966L31.8413 24.0404C35.7269 21.6385 40.7262 22.888 43.0697 26.7801Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_1773_381)">
        <rect x="6" y="22.8301" width="66.3454" height="76.6031" fill="url(#pattern3_1773_381)" />
      </g>
      <path
        d="M25.8145 37.607C26.4072 37.2406 26.9935 37.0136 27.6465 36.8976C28.2301 36.8161 28.8581 36.8086 29.4649 36.9158C30.0021 37.0575 30.5799 37.2671 31.0634 37.6197C31.6089 37.9255 31.9793 38.3904 32.3022 38.9268L33.0075 40.0982C33.1783 40.3818 33.1582 40.648 32.9467 40.8972L30.3625 43.51C30.1473 43.753 29.9527 43.7295 29.782 43.4458L28.5755 41.4421C28.4492 41.2324 28.2791 41.1006 27.9962 41.0809C27.7754 41.0144 27.5371 41.0686 27.3395 41.1907L27.0764 41.3533C26.813 41.5161 26.7219 41.6656 26.6134 41.9357C26.5671 42.1589 26.6054 42.3722 26.7316 42.5819L28.4206 45.387C28.5543 45.609 28.7391 45.7656 28.9052 45.8914C29.0676 46.011 29.2994 46.0959 29.5314 46.1809L35.6967 46.5153C36.1968 46.5954 36.6385 46.7287 36.8826 46.984C37.1925 47.1985 37.4624 47.4969 37.6851 47.8668L40.8777 53.1692C41.197 53.6994 41.4354 54.2455 41.4579 54.8831C41.5424 55.4738 41.462 56.0904 41.3443 56.6453C41.157 57.2349 40.8631 57.7973 40.5283 58.2919C40.124 58.8211 39.6602 59.2516 39.0675 59.618L37.816 60.3916C37.2891 60.7173 36.6337 60.9786 36.0502 61.0601C35.3971 61.1762 34.769 61.1836 34.2318 61.0419C33.6251 60.9347 33.1127 60.6847 32.5671 60.3789C32.0837 60.0263 31.6477 59.6023 31.3284 59.0721L29.5464 56.1125C29.3719 55.8227 29.3924 55.5563 29.6735 55.2726L32.1915 52.7007C32.4688 52.4108 32.6638 52.4341 32.8382 52.7239L35.1214 56.5159C35.244 56.7194 35.4135 56.8512 35.6343 56.9177C35.9172 56.9374 36.0938 56.9299 36.3572 56.767L36.6203 56.6044C36.8178 56.4823 36.9707 56.2862 37.017 56.063C37.1255 55.7929 37.0878 55.5796 36.9653 55.3761L34.5152 51.3069C34.286 51.0763 34.1448 50.8421 33.9564 50.6794C33.7644 50.5105 33.5214 50.4065 33.2273 50.3683L27.1091 49.9627C26.6053 49.8765 26.2333 49.7089 25.9308 49.5067C25.5588 49.3391 25.2625 48.9976 24.9803 48.529L22.7529 44.8298C22.43 44.2934 22.2572 43.7062 22.1726 43.1155C22.1502 42.478 22.1652 41.9019 22.3524 41.3123C22.4701 40.7574 22.764 40.1949 23.1684 39.6657C23.5032 39.1712 24.0361 38.7064 24.5629 38.3807L25.8145 37.607Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.9824 56.03C69.2492 53.0243 72.2043 51.0625 75.5824 51.0625C78.5382 51.0625 81.4974 53.0243 83.1865 56.03L95.8544 86.0868L128.79 88.8834C132.168 89.1757 134.703 91.3468 135.97 94.4778C136.814 97.567 135.967 100.99 133.434 103.119L108.522 124.493L116.122 156.304C116.545 159.476 115.279 162.774 112.745 164.695C110.211 166.615 106.409 166.781 103.875 165.07L75.5824 148.205L47.2939 165.07C44.338 166.781 40.5368 166.615 38.0032 164.695C35.4696 162.774 34.202 159.476 35.0465 156.304L42.2259 124.493L17.3105 103.119C14.7769 100.99 13.9324 97.567 15.1992 94.4778C16.0437 91.3468 19.0021 89.1757 21.9579 88.8834L54.8938 86.0868L67.9824 56.03Z"
        fill="#265DA6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.3825 52.7733C62.9161 46.8454 68.8262 42.9219 75.5824 42.9219C81.9164 42.9219 87.8281 46.8454 90.3617 52.7733L101.343 78.4058L129.211 80.7846C135.967 81.3273 141.458 85.753 143.57 91.8897L144.415 96.6482L143.57 101.366L141.879 105.707C141.034 107.043 139.768 108.254 138.502 109.339L117.388 127.457L123.722 154.383L124.143 159.225L123.302 163.859C122.035 166.823 119.922 169.411 117.388 171.331C112.321 175.088 105.142 175.423 99.6524 172.083L75.5824 157.639L51.0918 172.083C45.6024 175.423 38.8453 175.088 33.3558 171.331C30.8222 169.411 28.7117 166.823 27.8672 163.859L26.6012 159.225L27.0218 154.383L33.3558 127.457L12.2425 109.339C10.9757 108.254 10.1345 107.043 9.28998 105.707L7.17865 101.366L6.75391 96.6482L7.17865 91.8897C9.28998 85.753 14.777 81.3273 21.5332 80.7846L49.4052 78.4058L60.3825 52.7733ZM22.7992 96.9825L47.7145 118.272C49.8258 120.234 51.091 123.366 50.2465 126.372L42.6465 158.056C42.6465 158.14 43.0712 158.14 43.0712 158.056L71.3598 141.191C73.8934 139.688 76.8509 139.688 79.3845 141.191L107.677 158.056C107.677 158.14 108.098 158.14 108.098 158.056L100.498 126.372C100.075 123.366 100.921 120.234 103.454 118.272L127.945 96.9825L95.0091 94.2266C92.0533 93.9762 89.5172 92.0979 88.2504 89.3427L75.5824 59.2441C75.5824 59.1606 75.5824 59.2023 75.5824 59.2023C75.1601 59.2023 75.1618 59.1606 75.1618 59.2441L62.4938 89.3427C61.227 92.0979 58.6951 93.9762 55.7392 94.2266L22.7992 96.9825ZM108.098 158.098C108.098 158.14 108.098 158.14 108.098 158.182V158.098ZM42.6465 158.098V158.182C42.6465 158.14 42.6465 158.14 42.6465 158.098Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.9824 56.03C69.2492 53.0243 72.2043 51.0625 75.5824 51.0625C78.5382 51.0625 81.4974 53.0243 83.1865 56.03L95.8544 86.0868L128.79 88.8834C132.168 89.1757 134.703 91.3468 135.97 94.4778C136.814 97.567 135.967 100.99 133.434 103.119L108.522 124.493L116.122 156.304C116.545 159.476 115.279 162.774 112.745 164.695C110.211 166.615 106.409 166.781 103.875 165.07L75.5824 148.205L47.2939 165.07C44.338 166.781 40.5368 166.615 38.0032 164.695C35.4696 162.774 34.202 159.476 35.0465 156.304L42.2259 124.493L17.3105 103.119C14.7769 100.99 13.9324 97.567 15.1992 94.4778C16.0437 91.3468 19.0021 89.1757 21.9579 88.8834L54.8938 86.0868L67.9824 56.03Z"
        fill="url(#paint0_linear_1773_381)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1773_381"
        x="0"
        y="0"
        width="150.758"
        height="180.384"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1773_381" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1773_381"
          result="shape"
        />
      </filter>
      <pattern id="pattern0_1773_381" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_1773_381" transform="scale(0.0126582 0.0121951)" />
      </pattern>
      <pattern id="pattern1_1773_381" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image1_1773_381" transform="scale(0.0131579 0.0104167)" />
      </pattern>
      <pattern id="pattern2_1773_381" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image2_1773_381" transform="scale(0.016129 0.0135135)" />
      </pattern>
      <pattern id="pattern3_1773_381" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image3_1773_381" transform="scale(0.0116279 0.0102041)" />
      </pattern>
      <linearGradient
        id="paint0_linear_1773_381"
        x1="115.7"
        y1="142.986"
        x2="50.3423"
        y2="89.9714"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CC0347" />
        <stop offset="1" stopColor="#FDC305" />
      </linearGradient>
      <image
        id="image0_1773_381"
        width="79"
        height="82"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
      <image
        id="image1_1773_381"
        width="76"
        height="96"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
      <image
        id="image2_1773_381"
        width="62"
        height="74"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABKCAYAAADjcueTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAADFElEQVR4nOWcv07cQBDGd080AZKCPA0SBX2gSZEiRYo0KXieFDQ8AhI6kFJQUCDlafJXSlI6BTfn3fHMzp69a+8Mn3QSHtbe/e77ec6+g/NuAZ0crTu/+dmHj46owbjOD2ubfaj6za8z2CS1V8IIpePX6y7cxubCGjkurAWmo3Eds3/nRE02jg1S4sxF26wJPxzr6CcwGbGwJlY5BlOTYHO1EA/r17953AeJTzFIaW7Ec5PcK20ULwZvz4F4DvYr4feTRZmbaoKmY7fzvJrxJRFfLPGWEQfVTXwhxHNey4sbbwnxdy9vWftFjddAnDqeOE9Go6uTeEHEqQsVXE/NzamY8ZYQ52qhihjXhDiobOINIV498VYRh/r7Q7qzTzLeOuKpRlcm8QYRr3YB0zri3DjQKONaEK/S3LQgXixxjYh/IDr7Tsa1Id6HNMx9XOJKEC9yjmtEPJwbK8u4ZsQnNzfNiI9KXDviUP94cBc9Rauv387ZHmAFcWrfvMQVI07VnUsYt4J4X4+3SePWEKfu1NKJG0JcPMctIs42N+js1hH/tN+/pNGJG0Mcj3MuMG4dcTyG7eqWEGfPcc6cNcTDY62ookXEkxcw1hH3zrmLF0+dfWv88Xt/s2IR8WRzew6Ig/iubgxxPAeZuGXEQfJtaXQg/YiHc2x1erTuwsWGiwoxw4vFaXP17b6JxUqIezR+UGOeEKwo8Qeqs6MdtCMO4m9LowPZQRyUfM8NY8YuTqhzi+XqFOJxXZiHmAMrK3HJhCbEQaTx/kD2EAclLmBsIg4aGL//EX/AYA1xEJ24YcRB4vvq1hAHiZes1GI1Iw7KS9wQ4qDsxKNJhbEtIw4ijX/52f+jmjXEQTt9dsbVNSEOyv4bGCuIg/jEjSIOSqI+WJwBxEHybSm1OFTThDho1AVMNEYZ4iDW+HrzVQPWEAclvzGgBuLU8eZE/PO/N965jK9KKI24Rw9uHDd3rsAgp3TiChCXDHLK+nKMpREfay4l8RyfE/HLv+UNchInevvqtotSzPjUxIW/R4h759zVn/kMcvoPeBynMxro0VYAAAAASUVORK5CYII="
      />
      <image
        id="image3_1773_381"
        width="86"
        height="98"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const WhatAreStarsIcon = ({ className, size = 181 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1869_6816)">
      <path
        d="M8 4.66699V14.0003"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.9987 12C1.82189 12 1.65232 11.9298 1.52729 11.8047C1.40227 11.6797 1.33203 11.5101 1.33203 11.3333V2.66667C1.33203 2.48986 1.40227 2.32029 1.52729 2.19526C1.65232 2.07024 1.82189 2 1.9987 2H5.33203C6.03928 2 6.71755 2.28095 7.21765 2.78105C7.71775 3.28115 7.9987 3.95942 7.9987 4.66667C7.9987 3.95942 8.27965 3.28115 8.77975 2.78105C9.27984 2.28095 9.95812 2 10.6654 2H13.9987C14.1755 2 14.3451 2.07024 14.4701 2.19526C14.5951 2.32029 14.6654 2.48986 14.6654 2.66667V11.3333C14.6654 11.5101 14.5951 11.6797 14.4701 11.8047C14.3451 11.9298 14.1755 12 13.9987 12H9.9987C9.46827 12 8.95956 12.2107 8.58448 12.5858C8.20941 12.9609 7.9987 13.4696 7.9987 14C7.9987 13.4696 7.78798 12.9609 7.41291 12.5858C7.03784 12.2107 6.52913 12 5.9987 12H1.9987Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1869_6816">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ProcessingCompletedTasksIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.5 14.1667L4.16667 15.8333L7.5 12.5"
      stroke="#9810FA"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 5.83464L4.16667 7.5013L7.5 4.16797"
      stroke="#9810FA"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8359 5H17.5026"
      stroke="#9810FA"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8359 10H17.5026"
      stroke="#9810FA"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8359 15H17.5026"
      stroke="#9810FA"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaptureStarsIcon = ({ className, size = 15 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_1869_6841)">
      <path
        d="M6.62625 10.3332C6.56674 10.1025 6.44648 9.89191 6.278 9.72343C6.10952 9.55495 5.89897 9.43469 5.66825 9.37517L1.57825 8.32051C1.50847 8.3007 1.44706 8.25867 1.40333 8.2008C1.3596 8.14293 1.33594 8.07238 1.33594 7.99984C1.33594 7.9273 1.3596 7.85675 1.40333 7.79888C1.44706 7.74101 1.50847 7.69898 1.57825 7.67917L5.66825 6.62384C5.89889 6.56438 6.10938 6.44422 6.27786 6.27587C6.44633 6.10751 6.56663 5.8971 6.62625 5.66651L7.68092 1.57651C7.70053 1.50645 7.74251 1.44474 7.80047 1.40077C7.85843 1.35681 7.92917 1.33301 8.00192 1.33301C8.07467 1.33301 8.14542 1.35681 8.20337 1.40077C8.26133 1.44474 8.30332 1.50645 8.32292 1.57651L9.37692 5.66651C9.43644 5.89722 9.5567 6.10777 9.72518 6.27625C9.89366 6.44473 10.1042 6.56499 10.3349 6.62451L14.4249 7.67851C14.4953 7.69791 14.5573 7.73985 14.6015 7.79789C14.6457 7.85594 14.6696 7.92688 14.6696 7.99984C14.6696 8.0728 14.6457 8.14374 14.6015 8.20179C14.5573 8.25983 14.4953 8.30177 14.4249 8.32117L10.3349 9.37517C10.1042 9.43469 9.89366 9.55495 9.72518 9.72343C9.5567 9.89191 9.43644 10.1025 9.37692 10.3332L8.32225 14.4232C8.30265 14.4932 8.26067 14.5549 8.20271 14.5989C8.14475 14.6429 8.074 14.6667 8.00125 14.6667C7.92851 14.6667 7.85776 14.6429 7.7998 14.5989C7.74184 14.5549 7.69986 14.4932 7.68025 14.4232L6.62625 10.3332Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.332 2V4.66667"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 3.33301H12"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66797 11.333V12.6663"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 12H2"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1869_6841">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DocumentIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12.5026 1.66797H5.0026C4.56058 1.66797 4.13665 1.84356 3.82409 2.15612C3.51153 2.46868 3.33594 2.89261 3.33594 3.33464V16.668C3.33594 17.11 3.51153 17.5339 3.82409 17.8465C4.13665 18.159 4.56058 18.3346 5.0026 18.3346H15.0026C15.4446 18.3346 15.8686 18.159 16.1811 17.8465C16.4937 17.5339 16.6693 17.11 16.6693 16.668V5.83464L12.5026 1.66797Z"
      stroke="currentColor"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6641 1.66797V5.0013C11.6641 5.44333 11.8397 5.86725 12.1522 6.17981C12.4648 6.49237 12.8887 6.66797 13.3307 6.66797H16.6641"
      stroke="currentColor"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33073 7.5H6.66406"
      stroke="currentColor"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3307 10.832H6.66406"
      stroke="currentColor"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3307 14.168H6.66406"
      stroke="currentColor"
      strokeWidth="1.39167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ── Capture STAR modal status indicators ── */

export const StepCheckCircleIcon = ({ className }: IconProps = {}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="10" cy="10" r="9" stroke="var(--color-goals-purple-selected)" strokeWidth="1.5" />
    <path
      d="M6.5 10.5L8.5 12.5L13.5 7.5"
      stroke="var(--color-goals-purple-selected)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GreenCheckCircleIcon = ({ className }: IconProps = {}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="8" cy="8" r="7" stroke="var(--color-build-progress-fill)" strokeWidth="1.5" />
    <path d="M5 8.5L7 10.5L11 6.5" stroke="var(--color-build-progress-fill)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const StepPendingCircleIcon = ({ className }: IconProps = {}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      stroke="var(--color-goals-purple-selected)"
      strokeWidth="1.5"
      strokeOpacity="0.4"
    />
  </svg>
);

export const StepSpinnerCircleIcon = ({ className }: IconProps = {}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`animate-spin ${className ?? ""}`}
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      stroke="var(--color-goals-purple-selected)"
      strokeWidth="1.5"
      strokeOpacity="0.2"
    />
    <path
      d="M10 1C14.9706 1 19 5.02944 19 10"
      stroke="var(--color-goals-purple-selected)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const ViewGoalsChevronIcon = ({ className }: IconProps = {}) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.5 9L7.5 6L4.5 3"
      stroke="var(--color-secondary-250)"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThunderIcon = ({ className, size = 13 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.16851 7.58344C2.06601 7.58379 1.96551 7.55505 1.8787 7.50056C1.79188 7.44606 1.72231 7.36805 1.67806 7.27559C1.63382 7.18313 1.61671 7.08001 1.62874 6.97822C1.64077 6.87642 1.68144 6.78013 1.74601 6.70053L7.10851 1.17553C7.14874 1.12909 7.20355 1.09772 7.26396 1.08655C7.32437 1.07538 7.38678 1.08507 7.44095 1.11405C7.49512 1.14302 7.53783 1.18955 7.56207 1.246C7.58631 1.30245 7.59064 1.36546 7.57435 1.42469L6.53435 4.68553C6.50368 4.7676 6.49338 4.85589 6.50433 4.94282C6.51529 5.02975 6.54716 5.11273 6.59723 5.18463C6.6473 5.25654 6.71406 5.31522 6.79179 5.35565C6.86952 5.39609 6.9559 5.41706 7.04351 5.41678H10.8352C10.9377 5.41643 11.0382 5.44517 11.125 5.49966C11.2118 5.55416 11.2814 5.63217 11.3256 5.72463C11.3699 5.81709 11.387 5.92021 11.375 6.022C11.3629 6.1238 11.3223 6.22009 11.2577 6.29969L5.89518 11.8247C5.85496 11.8711 5.80014 11.9025 5.73973 11.9137C5.67932 11.9248 5.61691 11.9151 5.56274 11.8862C5.50857 11.8572 5.46586 11.8107 5.44162 11.7542C5.41738 11.6978 5.41306 11.6348 5.42935 11.5755L6.46935 8.31469C6.50001 8.23262 6.51031 8.14433 6.49936 8.0574C6.48841 7.97047 6.45653 7.88749 6.40647 7.81559C6.3564 7.74368 6.28964 7.685 6.21191 7.64456C6.13418 7.60413 6.0478 7.58316 5.96018 7.58344H2.16851Z"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StringVsWeakWritingIcon = ({ className, size = 13 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.9193 3.79297L7.3151 8.39714L4.60677 5.6888L1.08594 9.20964"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.66406 3.79297H11.9141V7.04297"
      stroke="currentColor"
      strokeWidth="1.08333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TipBulbIcon = ({ className }: IconProps = {}) => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#tipbulb-clip)">
      <path d="M6.875 6.4165C6.96667 5.95817 7.19583 5.63734 7.5625 5.27067C8.02083 4.85817 8.25 4.26234 8.25 3.6665C8.25 2.93716 7.96027 2.23769 7.44454 1.72196C6.92882 1.20624 6.22935 0.916504 5.5 0.916504C4.77065 0.916504 4.07118 1.20624 3.55546 1.72196C3.03973 2.23769 2.75 2.93716 2.75 3.6665C2.75 4.12484 2.84167 4.67484 3.4375 5.27067C3.75833 5.5915 4.03333 5.95817 4.125 6.4165" stroke="#FE9A00" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.125 8.25H6.875" stroke="#FE9A00" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.58398 10.0835H6.41732" stroke="#FE9A00" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="tipbulb-clip">
        <rect width="11" height="11" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const SituationLetterIcon = ({ className }: IconProps = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="33"
    viewBox="0 0 15 33"
    fill="none"
    className={className}
  >
    <path
      d="M8.2002 0C9.10019 0 9.9002 0.147834 10.7002 0.461982C11.4002 0.76689 12.1002 1.18276 12.7002 1.70942C13.2002 2.22684 13.7 2.8459 14 3.55735C14.4 4.25956 14.5 5.0174 14.5 5.82124V7.57668C14.5 8.00171 14.3004 8.27881 13.9004 8.40816L9.2998 9.5171C8.89981 9.63721 8.7002 9.48014 8.7002 9.05512V6.05223C8.7002 5.73809 8.5998 5.47929 8.2998 5.26678C8.0998 5.04502 7.8 4.9433 7.5 4.9433H7.10059C6.70059 4.9433 6.5002 5.04502 6.2002 5.26678C6.0002 5.47929 5.90039 5.73809 5.90039 6.05223V10.2561C5.90039 10.5887 6.00059 10.8846 6.10059 11.134C6.20059 11.3743 6.40059 11.6236 6.60059 11.873L13.2002 16.4004C13.7002 16.8254 14.1002 17.2693 14.2002 17.7128C14.4002 18.1563 14.5 18.6643 14.5 19.2187V27.1649C14.5 27.9595 14.4 28.7169 14 29.4283C13.7 30.1306 13.2002 30.7496 12.7002 31.2763C12.1002 31.7937 11.4002 32.2096 10.7002 32.5237C9.9002 32.8286 9.10019 32.9857 8.2002 32.9857H6.2998C5.4998 32.9857 4.60039 32.8286 3.90039 32.5237C3.10039 32.2096 2.40039 31.7937 1.90039 31.2763C1.30039 30.7496 0.9 30.1306 0.5 29.4283C0.2 28.7169 0 27.9595 0 27.1649V22.7296C0 22.2953 0.200195 22.0182 0.700195 21.8981L5.2002 20.7892C5.7002 20.6598 5.90039 20.8169 5.90039 21.2512V26.9339C5.90039 27.2388 6.0002 27.4972 6.2002 27.7189C6.5002 27.9314 6.70059 28.0424 7.10059 28.0424H7.5C7.8 28.0424 8.0998 27.9314 8.2998 27.7189C8.5998 27.4972 8.7002 27.2388 8.7002 26.9339V20.8357C8.60019 20.4291 8.6 20.0781 8.5 19.7732C8.4 19.459 8.20039 19.1815 7.90039 18.9413L1.40039 14.3679C0.900391 13.9336 0.600391 13.4995 0.400391 13.0745C0.100391 12.6402 0 12.0672 0 11.365V5.82124C0 5.0174 0.2 4.25956 0.5 3.55735C0.9 2.8459 1.30039 2.22684 1.90039 1.70942C2.40039 1.18276 3.10039 0.76689 3.90039 0.461982C4.60039 0.147834 5.4998 0 6.2998 0H8.2002Z"
      fill="currentColor"
    />
  </svg>
);

export const TaskLetterIcon = ({ className }: IconProps = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="33"
    viewBox="0 0 15 33"
    fill="none"
    className={className}
  >
    <path
      d="M13.6006 0.398438C14.1006 0.398438 14.2998 0.61113 14.2998 1.04539V5.15676C14.2998 5.58179 14.1006 5.80372 13.6006 5.80372H10.1006V32.0907C10.1006 32.5157 9.80039 32.7372 9.40039 32.7372H4.90039C4.80039 32.7372 4.6 32.6728 4.5 32.5527C4.3 32.4233 4.2002 32.2755 4.2002 32.0907V5.80372H0.700195C0.300195 5.80372 0 5.58179 0 5.15676V1.04539C0 0.61113 0.300195 0.398438 0.700195 0.398438H13.6006Z"
      fill="currentColor"
    />
  </svg>
);

export const ActionLetterIcon = ({ className }: IconProps = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="33"
    viewBox="0 0 16 33"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6992 31.6922C15.7992 32.1173 15.5996 32.3387 15.0996 32.3387H10.5996C10.0996 32.3387 9.89981 32.1173 9.7998 31.6922L9.39941 26.7025H6.2998L5.89941 31.6922C5.89941 32.1173 5.59922 32.3387 5.19922 32.3387H0.599609C0.199609 32.3387 0 32.1173 0 31.6922L3.7998 0.646955C3.7998 0.212692 4.09961 0 4.59961 0H11.1992C11.5992 0 11.9 0.212692 12 0.646955L15.6992 31.6922ZM9 21.5286L8.09961 9.00865H7.69922L6.69922 21.5286H9Z"
      fill="currentColor"
    />
  </svg>
);

export const ResultLetterIcon = ({ className }: IconProps = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="33"
    viewBox="0 0 16 33"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5 31.6922C15.6 32.1173 15.5 32.3387 15 32.3387H10.5C10.3 32.3387 10.0994 32.2743 9.89941 32.1542C9.69941 32.0249 9.6 31.877 9.5 31.6922L5.89941 20.3737V32.3387L5.7998 31.8768C5.7998 32.1817 5.49922 32.3387 5.19922 32.3387H0.699219C0.299219 32.3387 0 32.1173 0 31.6922V0.646955C0 0.212692 0.299219 0 0.699219 0H8.19922C9.09922 0 9.89922 0.147834 10.6992 0.461982C11.3992 0.76689 12.0992 1.18276 12.6992 1.70942C13.1992 2.22684 13.7 2.8459 14 3.55735C14.4 4.25956 14.5 5.0174 14.5 5.82124V13.3515C14.5 14.4879 14.1996 15.5134 13.5996 16.4189C12.8996 17.3243 12.0996 18.0268 11.0996 18.5257L15.5 31.6922ZM5.89941 14.229H7.5C7.8 14.229 8.0998 14.1184 8.2998 13.9059C8.5998 13.6842 8.69922 13.4254 8.69922 13.1205V6.05224C8.69922 5.73809 8.5998 5.47929 8.2998 5.26678C8.0998 5.04502 7.8 4.9433 7.5 4.9433H5.89941V14.229Z"
      fill="currentColor"
    />
  </svg>
);

export const TipsTargetIcon = ({ className, size = 24 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="12" cy="12" r="2" fill="currentColor" />
    <path d="M12 2V4M12 20V22M2 12H4M20 12H22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const TipsNoteIcon = ({ className, size = 11 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.75 1.375H8.25C8.5 1.375 8.708 1.468 8.87 1.63C9.032 1.792 9.125 2 9.125 2.25V8.75C9.125 9 9.032 9.208 8.87 9.37C8.708 9.532 8.5 9.625 8.25 9.625H2.75C2.5 9.625 2.292 9.532 2.13 9.37C1.968 9.208 1.875 9 1.875 8.75V2.25C1.875 2 1.968 1.792 2.13 1.63C2.292 1.468 2.5 1.375 2.75 1.375Z"
      stroke="currentColor"
      strokeWidth="0.916667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.625 4.125H7.375M3.625 5.875H7.375M3.625 7.625H5.5" stroke="currentColor" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BulletsIconStars = ({ className }: IconProps = {}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <mask id="bullets-stars-mask" fill="white">
      <path d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"/>
    </mask>
    <path d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z" fill="white"/>
    <path d="M0 8M16 8M16 8M0 8M8 0M16 8M8 16M0 8M8 16V15C4.13401 15 1 11.866 1 8H0H-1C-1 12.9706 3.02944 17 8 17V16ZM16 8H15C15 11.866 11.866 15 8 15V16V17C12.9706 17 17 12.9706 17 8H16ZM8 0V1C11.866 1 15 4.13401 15 8H16H17C17 3.02944 12.9706 -1 8 -1V0ZM8 0V-1C3.02944 -1 -1 3.02944 -1 8H0H1C1 4.13401 4.13401 1 8 1V0Z" fill="#DAB2FF" mask="url(#bullets-stars-mask)"/>
    <path d="M7.37109 10.5L9.62109 8.25L7.37109 6" stroke="#DAB2FF" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* Strong version tick — 14×14 green circle with checkmark */
export const StrongCheckCircleIcon = ({ className }: IconProps = {}) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M7.0013 12.8332C10.223 12.8332 12.8346 10.2215 12.8346 6.99984C12.8346 3.77818 10.223 1.1665 7.0013 1.1665C3.77964 1.1665 1.16797 3.77818 1.16797 6.99984C1.16797 10.2215 3.77964 12.8332 7.0013 12.8332Z" stroke="#009966" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.25 7.00016L6.41667 8.16683L8.75 5.8335" stroke="#009966" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* Weak cross container — 20px-height pill, red bg, X icon */
export const WeakCrossIcon = ({ className }: IconProps = {}) => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M8.25 2.75L2.75 8.25" stroke="currentColor" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.75 2.75L8.25 8.25" stroke="currentColor" strokeWidth="0.916667" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* Book / knowledge icon — Keep Situation brief (tip 3) */
export const BookIcon = ({ className, size = 22 }: IconProps = {}) => (
  <svg width={size} height={Math.round(size * 20 / 22)} viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M2 16C1.73478 16 1.48043 15.8946 1.29289 15.7071C1.10536 15.5196 1 15.2652 1 15V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H7C8.06087 1 9.07828 1.42143 9.82843 2.17157C10.5786 2.92172 11 3.93913 11 5C11 3.93913 11.4214 2.92172 12.1716 2.17157C12.9217 1.42143 13.9391 1 15 1H20C20.2652 1 20.5196 1.10536 20.7071 1.29289C20.8946 1.48043 21 1.73478 21 2V15C21 15.2652 20.8946 15.5196 20.7071 15.7071C20.5196 15.8946 20.2652 16 20 16H14C13.2044 16 12.4413 16.3161 11.8787 16.8787C11.3161 17.4413 11 18.2044 11 19C11 18.2044 10.6839 17.4413 10.1213 16.8787C9.55871 16.3161 8.79565 16 8 16H2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/* Achievement badge — Connect to business value (tip 5 + AllDone) */
export const AchievementBadgeIcon = ({ className, size = 24 }: IconProps = {}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M15.4768 12.8896L16.9918 21.4156C17.0087 21.516 16.9946 21.6192 16.9514 21.7114C16.9081 21.8036 16.8377 21.8803 16.7497 21.9314C16.6616 21.9825 16.56 22.0055 16.4586 21.9974C16.3571 21.9892 16.2605 21.9502 16.1818 21.8856L12.6018 19.1986C12.4289 19.0695 12.219 18.9998 12.0033 18.9998C11.7875 18.9998 11.5776 19.0695 11.4048 19.1986L7.81875 21.8846C7.74007 21.9491 7.64361 21.988 7.54225 21.9962C7.44088 22.0044 7.33942 21.9815 7.25141 21.9305C7.16341 21.8796 7.09303 21.803 7.04967 21.711C7.00631 21.619 6.99204 21.516 7.00875 21.4156L8.52275 12.8896" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
export const CalendarConnectIcon = ({ className, size = 36 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M12 3V9" stroke="#4051B5" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24 3V9" stroke="#4051B5" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M28.5 6H7.5C5.84315 6 4.5 7.34315 4.5 9V30C4.5 31.6569 5.84315 33 7.5 33H28.5C30.1569 33 31.5 31.6569 31.5 30V9C31.5 7.34315 30.1569 6 28.5 6Z" stroke="#4051B5" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 15H31.5" stroke="#4051B5" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CalendarConnectedIcon = ({ className, size = 36 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="3" y="6" width="30" height="27" rx="3" stroke="#00bc7d" strokeWidth="2" />
    <path d="M3 13H33" stroke="#00bc7d" strokeWidth="2" />
    <path d="M11 3V9M25 3V9" stroke="#00bc7d" strokeWidth="2" strokeLinecap="round" />
    <rect x="8" y="18" width="5" height="4" rx="1" fill="#00bc7d" opacity="0.5" />
    <rect x="16" y="18" width="5" height="4" rx="1" fill="#00bc7d" opacity="0.5" />
    <rect x="24" y="18" width="5" height="4" rx="1" fill="#00bc7d" opacity="0.5" />
    <rect x="8" y="25" width="5" height="4" rx="1" fill="#00bc7d" opacity="0.3" />
    <rect x="16" y="25" width="5" height="4" rx="1" fill="#00bc7d" opacity="0.3" />
  </svg>
);

export const CalendarLinkIcon = ({ className, size = 18 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="1.5" y="3" width="15" height="13.5" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M1.5 7H16.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M6 1.5V4.5M12 1.5V4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const GoogleCalendarIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 01-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.35z"
      fill="#4285F4"
    />
    <path
      d="M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0010 20z"
      fill="#34A853"
    />
    <path
      d="M4.405 11.9A6.01 6.01 0 014.09 10c0-.663.114-1.308.314-1.9V5.51H1.064A9.995 9.995 0 000 10c0 1.614.386 3.14 1.064 4.49l3.34-2.59z"
      fill="#FBBC05"
    />
    <path
      d="M10 3.977c1.468 0 2.786.505 3.822 1.496l2.868-2.868C14.959.99 12.695 0 10 0 6.09 0 2.71 2.24 1.064 5.51l3.34 2.59C5.192 5.736 7.396 3.977 10 3.977z"
      fill="#EA4335"
    />
  </svg>
);

export const OutlookCalendarIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="1" y="1" width="10" height="10" rx="1.5" fill="#0078D4" />
    <rect x="1" y="12" width="10" height="7" rx="1.5" fill="#0078D4" opacity="0.7" />
    <rect x="12" y="1" width="7" height="7" rx="1.5" fill="#0078D4" opacity="0.5" />
    <rect x="12" y="9" width="7" height="10" rx="1.5" fill="#0078D4" opacity="0.85" />
  </svg>
);

export const AppleCalendarIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.073 10.625c-.02-2.084 1.703-3.088 1.78-3.138-.97-1.42-2.481-1.614-3.02-1.636-1.285-.13-2.516.758-3.168.758-.652 0-1.657-.741-2.727-.72-1.398.02-2.693.814-3.414 2.066-1.456 2.524-.373 6.258 1.047 8.305.693 1.002 1.523 2.126 2.611 2.085 1.047-.04 1.44-.676 2.706-.676 1.265 0 1.619.676 2.727.655 1.128-.02 1.843-1.022 2.53-2.027.8-1.163 1.13-2.289 1.148-2.347-.025-.01-2.196-.844-2.22-3.325z"
      fill="#555"
    />
    <path
      d="M12.99 4.17c.574-.7.963-1.674.857-2.645-.827.034-1.83.55-2.423 1.242-.531.617-.996 1.607-.87 2.558.92.07 1.863-.467 2.436-1.155z"
      fill="#555"
    />
  </svg>
);

export const InfoCircleIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8 7V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="8" cy="5" r="0.75" fill="currentColor" />
  </svg>
);

export const ArrowRightIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4 10H16M16 10L11 5M16 10L11 15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarCheckIcon = ({ className, size = 16 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3 8L6.5 11.5L13 5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Checkmark shown inside a completed step circle in the marketing panel */
export const PanelStepCheckIcon = ({ className }: IconProps = {}) => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1 4L3.5 6.5L9 1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Star shown inside the badge pill in the marketing panel */
export const PanelBadgeStarIcon = ({ className }: IconProps = {}) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.5 0L6.798 4.007H11L7.601 6.486L8.899 10.493L5.5 8.014L2.101 10.493L3.399 6.486L0 4.007H4.202L5.5 0Z"
      fill="currentColor"
    />
  </svg>
);

/** Checkmark shown inside each bullet point circle in the marketing panel */
export const PanelBulletCheckIcon = ({ className }: IconProps = {}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_1448_459)">
      <path
        d="M5.49996 10.0834C8.03126 10.0834 10.0833 8.03139 10.0833 5.50008C10.0833 2.96878 8.03126 0.916748 5.49996 0.916748C2.96865 0.916748 0.916626 2.96878 0.916626 5.50008C0.916626 8.03139 2.96865 10.0834 5.49996 10.0834Z"
        stroke="white"
        strokeWidth="0.916667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.125 5.49992L5.04167 6.41659L6.875 4.58325"
        stroke="white"
        strokeWidth="0.916667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1448_459">
        <rect width="11" height="11" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/** Filled check-circle icon used to indicate a verified/signed-in state */
export const CheckCircleFilledIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 0C3.13 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm-1.5 10.5L2 7l1.41-1.41L5.5 7.67l5.09-5.09L12 4l-6.5 6.5z"
      fill="currentColor"
    />
  </svg>
);

/** Full LinkedIn brand box icon (white fill, for SSO buttons) */
export const LinkedInBrandIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.04 17.043h-2.962v-4.64c0-1.107-.023-2.531-1.544-2.531-1.544 0-1.78 1.204-1.78 2.449v4.722H7.793V7.5h2.844v1.305h.04c.396-.75 1.364-1.542 2.807-1.542 3.001 0 3.556 1.975 3.556 4.545v5.235zM4.447 6.194a1.72 1.72 0 0 1-1.72-1.72 1.72 1.72 0 1 1 1.72 1.72zm1.484 10.849H2.963V7.5h2.968v9.543zM18.521 0H1.476C.66 0 0 .645 0 1.44v17.12C0 19.355.66 20 1.476 20h17.04C19.34 20 20 19.355 20 18.56V1.44C20 .645 19.34 0 18.521 0z"
      fill="currentColor"
    />
  </svg>
);

/** Google brand icon (multi-colour G logo, for SSO buttons) */
export const GoogleIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 0 1-1.996 3.018v2.51h3.232c1.89-1.742 2.982-4.305 2.982-7.35z"
      fill="#4285F4"
    />
    <path
      d="M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0 0 10 20z"
      fill="#34A853"
    />
    <path
      d="M4.405 11.9A6.01 6.01 0 0 1 4.09 10c0-.663.114-1.308.314-1.9V5.51H1.064A9.996 9.996 0 0 0 0 10c0 1.614.386 3.14 1.064 4.49l3.34-2.59z"
      fill="#FBBC05"
    />
    <path
      d="M10 3.977c1.468 0 2.786.505 3.822 1.496l2.868-2.868C14.959.99 12.695 0 10 0A9.996 9.996 0 0 0 1.064 5.51l3.34 2.59C5.192 5.736 7.396 3.977 10 3.977z"
      fill="#EA4335"
    />
  </svg>
);

export const TickMarkIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.6667 5L7.50001 14.1667L3.33334 10"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Copy squares icon (two overlapping rectangles) — used in Share/Export modal Quick Actions
export const CopySquaresIcon = ({ className, size = 20, color = "#5145CD" }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.666 6.66699H8.33268C7.41221 6.66699 6.66602 7.41318 6.66602 8.33366V16.667C6.66602 17.5875 7.41221 18.3337 8.33268 18.3337H16.666C17.5865 18.3337 18.3327 17.5875 18.3327 16.667V8.33366C18.3327 7.41318 17.5865 6.66699 16.666 6.66699Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33268 13.3337C2.41602 13.3337 1.66602 12.5837 1.66602 11.667V3.33366C1.66602 2.41699 2.41602 1.66699 3.33268 1.66699H11.666C12.5827 1.66699 13.3327 2.41699 13.3327 3.33366"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Chain-link icon for Share Link row — gray, 14×14
export const ShareLinkChainIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_share_link_chain)">
      <path
        d="M5.83398 7.58299C6.0845 7.9179 6.40411 8.19501 6.77114 8.39554C7.13817 8.59606 7.54403 8.71531 7.9612 8.74518C8.37836 8.77506 8.79708 8.71487 9.18894 8.56869C9.5808 8.42252 9.93663 8.19378 10.2323 7.89799L11.9823 6.14799C12.5136 5.5979 12.8076 4.86114 12.801 4.0964C12.7943 3.33166 12.4876 2.60012 11.9468 2.05935C11.406 1.51858 10.6745 1.21183 9.90974 1.20519C9.145 1.19854 8.40824 1.49253 7.85815 2.02382L6.85482 3.02132"
        stroke="#9CA3AF"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16629 6.41672C7.91578 6.08181 7.59617 5.80469 7.22914 5.60417C6.86211 5.40364 6.45625 5.2844 6.03908 5.25452C5.62192 5.22465 5.2032 5.28484 4.81134 5.43101C4.41948 5.57719 4.06364 5.80593 3.76796 6.10172L2.01796 7.85172C1.48667 8.40181 1.19268 9.13856 1.19933 9.9033C1.20597 10.668 1.51272 11.3996 2.05349 11.9404C2.59426 12.4811 3.3258 12.7879 4.09054 12.7945C4.85528 12.8012 5.59204 12.5072 6.14213 11.9759L7.13963 10.9784"
        stroke="#9CA3AF"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_share_link_chain">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ProgramsTabIcon = ({ className, size = 20 }: IconProps = {}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="1.667" y="1.667" width="6.667" height="6.667" rx="1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="11.667" y="1.667" width="6.667" height="6.667" rx="1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="1.667" y="11.667" width="6.667" height="6.667" rx="1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="11.667" y="11.667" width="6.667" height="6.667" rx="1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

interface AstronautIconProps {
  mouseX?: number;
  mouseY?: number;
  className?: string;
}

export const AstronautIcon = ({ mouseX = 50, mouseY = 50, className }: AstronautIconProps) => {
  const eyeOffsetX = Math.max(-3, Math.min(3, (mouseX - 50) * 0.06));
  const eyeOffsetY = Math.max(-2, Math.min(2, (mouseY - 50) * 0.04));

  return (
    <svg
      width="160"
      height="220"
      viewBox="0 0 160 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ overflow: "visible" }}
    >
      <defs>
        <style>{`
          @keyframes astro-arm-l {
            0%, 100% { d: path("M42 120 C25 130 18 148 22 162 C26 176 38 180 44 172"); }
            50%       { d: path("M42 120 C22 128 14 146 18 162 C22 178 36 182 44 172"); }
          }
          @keyframes astro-arm-r {
            0%, 100% { d: path("M118 120 C135 130 142 148 138 162 C134 176 122 180 116 172"); }
            50%       { d: path("M118 120 C138 128 146 146 142 162 C138 178 124 182 116 172"); }
          }
          @keyframes astro-leg-l {
            0%, 100% { d: path("M62 188 C58 200 55 212 56 220"); }
            50%       { d: path("M62 188 C59 200 57 212 58 220"); }
          }
          @keyframes astro-leg-r {
            0%, 100% { d: path("M98 188 C102 200 105 212 104 220"); }
            50%       { d: path("M98 188 C101 200 103 212 102 220"); }
          }
          @keyframes astro-sweat {
            0%, 100% { transform: translateY(0px); opacity: 0.8; }
            50%       { transform: translateY(6px);  opacity: 0.3; }
          }
          .astro-arm-l  { animation: astro-arm-l  4s ease-in-out infinite; }
          .astro-arm-r  { animation: astro-arm-r  4s ease-in-out infinite 0.3s; }
          .astro-leg-l  { animation: astro-leg-l  4s ease-in-out infinite; }
          .astro-leg-r  { animation: astro-leg-r  4s ease-in-out infinite 0.2s; }
          .astro-sweat  { animation: astro-sweat  2s ease-in-out infinite 1s; }
          .astro-glove-l { animation: glove-l 4s ease-in-out infinite; }
          .astro-glove-r { animation: glove-r 4s ease-in-out infinite 0.3s; }
          .astro-suit   { animation: suit-squish 4s ease-in-out infinite; transform-origin: 80px 140px; }
        `}</style>

        <linearGradient id="nf-suitGrad" x1="40" y1="90" x2="120" y2="192" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#e0e7ff" />
          <stop offset="50%" stopColor="#c7d2fe" />
          <stop offset="100%" stopColor="#a5b4fc" />
        </linearGradient>
        <linearGradient id="nf-armGrad" x1="0" y1="0" x2="1" y2="0" gradientUnits="objectBoundingBox">
          <stop offset="0%" stopColor="#c7d2fe" />
          <stop offset="100%" stopColor="#e0e7ff" />
        </linearGradient>
        <linearGradient id="nf-legGrad" x1="0" y1="0" x2="0" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0%" stopColor="#c7d2fe" />
          <stop offset="100%" stopColor="#a5b4fc" />
        </linearGradient>
        <linearGradient id="nf-gloveGrad" x1="0" y1="0" x2="1" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0%" stopColor="#c084fc" />
          <stop offset="100%" stopColor="#818cf8" />
        </linearGradient>
        <radialGradient id="nf-helmetGrad" cx="40%" cy="35%" r="60%">
          <stop offset="0%" stopColor="#ddd6fe" />
          <stop offset="60%" stopColor="#a5b4fc" />
          <stop offset="100%" stopColor="#6366f1" />
        </radialGradient>
        <radialGradient id="nf-visorGrad" cx="35%" cy="30%" r="70%">
          <stop offset="0%" stopColor="#1e3a5f" />
          <stop offset="50%" stopColor="#0f1d4a" />
          <stop offset="100%" stopColor="#060b2e" />
        </radialGradient>
        <linearGradient id="nf-ringGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#818cf8" />
          <stop offset="50%" stopColor="#c084fc" />
          <stop offset="100%" stopColor="#38bdf8" />
        </linearGradient>
        <linearGradient id="nf-patchGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4f46e5" />
          <stop offset="100%" stopColor="#7c3aed" />
        </linearGradient>
      </defs>

      {/* Suit body — subtle squish */}
      <ellipse cx="80" cy="140" rx="42" ry="52" fill="url(#nf-suitGrad)" className="astro-suit" />

      {/* Arms — path morph */}
      <path className="astro-arm-l" d="M42 120 C25 130 18 148 22 162 C26 176 38 180 44 172" stroke="url(#nf-armGrad)" strokeWidth="20" strokeLinecap="round" fill="none" />
      <path className="astro-arm-r" d="M118 120 C135 130 142 148 138 162 C134 176 122 180 116 172" stroke="url(#nf-armGrad)" strokeWidth="20" strokeLinecap="round" fill="none" />

      {/* Gloves — swing with arm */}
      <ellipse cx="23" cy="168" rx="13" ry="10" fill="url(#nf-gloveGrad)" className="astro-glove-l" style={{ transformOrigin: "23px 168px" }} />
      <ellipse cx="137" cy="168" rx="13" ry="10" fill="url(#nf-gloveGrad)" className="astro-glove-r" style={{ transformOrigin: "137px 168px" }} />

      {/* Legs — path morph */}
      <path className="astro-leg-l" d="M62 188 C58 200 55 212 56 220" stroke="url(#nf-legGrad)" strokeWidth="18" strokeLinecap="round" fill="none" />
      <path className="astro-leg-r" d="M98 188 C102 200 105 212 104 220" stroke="url(#nf-legGrad)" strokeWidth="18" strokeLinecap="round" fill="none" />

      {/* Helmet outer */}
      <circle cx="80" cy="82" r="48" fill="url(#nf-helmetGrad)" />

      {/* Helmet visor */}
      <ellipse cx="80" cy="86" rx="32" ry="30" fill="url(#nf-visorGrad)" />

      {/* Visor reflections */}
      <ellipse cx="68" cy="74" rx="10" ry="7" fill="rgba(255,255,255,0.18)" transform="rotate(-20 68 74)" />
      <ellipse cx="88" cy="70" rx="5" ry="3" fill="rgba(255,255,255,0.12)" transform="rotate(-20 88 70)" />

      {/* Eyes — follow mouse via prop-driven cx/cy */}
      <circle cx={65 + eyeOffsetX} cy={85 + eyeOffsetY} r="6" fill="#1e1b4b" style={{ transition: "cx 0.1s ease-out, cy 0.1s ease-out" }} />
      <circle cx={95 + eyeOffsetX} cy={85 + eyeOffsetY} r="6" fill="#1e1b4b" style={{ transition: "cx 0.1s ease-out, cy 0.1s ease-out" }} />

      {/* Eye shine */}
      <circle cx={67 + eyeOffsetX} cy={83 + eyeOffsetY} r="2" fill="white" opacity={0.9} style={{ transition: "cx 0.1s ease-out, cy 0.1s ease-out" }} />
      <circle cx={97 + eyeOffsetX} cy={83 + eyeOffsetY} r="2" fill="white" opacity={0.9} style={{ transition: "cx 0.1s ease-out, cy 0.1s ease-out" }} />

      {/* Confused squiggly mouth */}
      <path d="M68 98 Q72 94 76 98 Q80 102 84 98 Q88 94 92 98" stroke="#1e1b4b" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity={0.7} />

      {/* Sweat drop */}
      <path className="astro-sweat" d="M104 66 Q107 60 110 66 Q110 72 107 74 Q104 72 104 66 Z" fill="#38bdf8" opacity={0.8} style={{ transformOrigin: "107px 66px" }} />

      {/* Helmet ring */}
      <circle cx="80" cy="82" r="48" stroke="url(#nf-ringGrad)" strokeWidth="4" fill="none" />

      {/* Suit chest patch */}
      <rect x="66" y="128" width="28" height="20" rx="4" fill="url(#nf-patchGrad)" opacity={0.9} />
      <text x="80" y="142" textAnchor="middle" fontSize="8" fill="white" fontFamily="monospace" opacity={0.8}>FA</text>

      {/* Suit buttons */}
      <circle cx="76" cy="158" r="3" fill="#6366f1" opacity={0.8} />
      <circle cx="84" cy="158" r="3" fill="#a78bfa" opacity={0.8} />
    </svg>
  );
};

/** Standalone tick mark — same stroke path used inside a completed program-wizard step circle. */
export const StepCompletedTickIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg width={size} height={(size * 10) / 14} viewBox="0 0 16 12" fill="none" className={className}>
    <path
      d="M1.5 6L6 10.5L14.5 1.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Round warning badge — filled circle with an exclamation mark (not a triangle). */
export const WarningRoundIcon = ({ className, size = 14 }: IconProps = {}) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" className={className}>
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8 4.5V8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="8" cy="11" r="1" fill="currentColor" />
  </svg>
);

/**
 * The NETWORK section mark in the navigation sidebar (Figma node 5:7607).
 *
 * The one genuinely custom glyph in that design — every other icon in the nav
 * is a Lucide shape re-exported by Figma (the SVGs come back with Lucide's own
 * 2/24 stroke ratio), so those are imported from lucide-react as the rest of
 * sidebar.config already does rather than duplicated here.
 *
 * Filled, not stroked, so it takes its colour from `currentColor` on the
 * wrapper and follows --theme-nav-section-network in both themes.
 */
export const NetworkSectionIcon = ({ className, size = 15 }: IconProps = {}) => (
  <svg
    width={size}
    height={(size * 16.4546) / 14.8588}
    viewBox="0 0 14.8588 16.4546"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12.1074 11.3823C12.7584 10.9784 13.3407 10.4455 13.8121 9.78604C14.3474 9.03855 14.685 8.2079 14.8368 7.35551C14.7682 7.21083 14.5837 7.24581 14.5837 7.24581C15.1407 6.11495 14.7018 4.6031 14.5656 4.19681C14.1485 3.03219 13.3805 1.97124 12.2894 1.19001C9.48633 -0.817342 5.62234 -0.225382 3.66082 2.51498C3.04355 3.377 2.68909 4.34752 2.57818 5.33732C1.53412 5.81835 0.851738 6.99623 0.667281 7.34466C0.112698 8.45144 -0.123603 9.73783 0.0632673 11.0664C0.545514 14.4807 3.64153 16.8666 6.97746 16.3952C9.63825 16.0191 11.6456 13.9394 12.1061 11.3823H12.1074ZM10.4098 3.33359C12.3039 4.27156 13.3937 6.05227 13.1321 7.58458C12.7222 7.72202 12.3967 7.53032 12.4027 8.2573C12.4064 8.64433 12.2737 8.92884 12.1086 9.13382C11.5238 5.84128 8.49411 3.56989 5.23175 4.03044C5.19919 4.03526 5.16906 4.04129 5.13651 4.04611C6.09133 2.65001 8.35909 2.31726 10.4098 3.33239V3.33359ZM9.48995 9.88613C8.82207 9.83425 8.12403 9.6474 7.44887 9.31344C5.83456 8.51412 4.80493 7.10236 4.69766 5.75448C5.27996 5.46392 6.24567 5.69779 6.50729 5.77856C7.70202 6.20295 8.78709 7.37845 9.2814 8.96259C9.37787 9.27246 9.44655 9.5811 9.48876 9.88732L9.48995 9.88613ZM7.41632 14.1877C5.65732 14.7363 3.43537 13.5862 2.70718 11.2472C2.34911 10.0971 2.43592 8.84927 2.81569 7.82692C3.2063 9.10004 4.00804 10.2671 5.18353 11.1098C6.4229 11.9971 7.86841 12.3757 9.26574 12.2865C8.92454 13.2124 8.28194 13.9177 7.41632 14.1877Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * The MINDSHARE section mark in the achiever navigation sidebar
 * (Figma node 3:4177).
 *
 * A different glyph AND a different accent from NETWORK's — the two section
 * headings are deliberately distinguishable, so this is its own icon rather
 * than the network mark recoloured. Filled with `currentColor` so the accent
 * comes from --theme-nav-section-mindshare in both themes.
 */
export const MindShareSectionIcon = ({ className, size = 15 }: IconProps = {}) => (
  <svg
    width={size}
    height={(size * 16) / 15}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M11.9103 4.10064L11.3313 5.03703C11.238 5.18854 11.2556 5.38351 11.378 5.51514L11.4928 5.64059C10.5076 5.63436 9.30173 5.68776 7.91421 5.86285L7.81833 2.77555L8.85143 3.58774C9.0583 3.75043 9.36733 3.63866 9.4178 3.38283L9.62086 2.37194C9.66249 2.16206 9.58806 1.94597 9.42408 1.80564L7.49418 0.150202C7.37179 0.0446418 7.21163 -0.00876083 7.0489 0.00117425L6.76383 0.0185606C6.62 0.0272538 6.48379 0.0893486 6.3854 0.193667L4.71532 1.93976C4.50844 2.15585 4.45295 2.47377 4.57529 2.74574L5.00797 3.71069C5.12022 3.96031 5.45576 4.01247 5.64119 3.81004L6.44215 2.93078L6.53929 6.07275C4.89948 6.37082 3.60656 6.79429 2.6479 7.19169L2.73998 6.98184C2.8144 6.81416 2.79044 6.61919 2.67943 6.47263L2.14838 5.77469C1.95917 5.52632 1.57067 5.55737 1.42561 5.83432L0.111232 8.33669C-0.00355433 8.55529 -0.0300417 8.80738 0.0342893 9.04458L0.229804 9.75246C0.284043 9.94867 0.396313 10.125 0.551467 10.2591L2.46247 11.9059C2.68321 12.0959 3.02757 12.0115 3.13227 11.7432L3.39717 11.0676C3.49303 10.8217 3.44131 10.5423 3.26093 10.3461L2.49022 9.50532C3.32653 9.0918 4.56017 8.65711 6.60865 8.29451L6.75876 13.1279L5.85183 12.574C5.62351 12.4349 5.32458 12.5678 5.27917 12.8286L5.07733 14.0158C5.03067 14.2866 5.14548 14.5586 5.37249 14.7188L7.00853 15.8737C7.13971 15.9669 7.30118 16.0103 7.46139 15.9979L7.82591 15.9693C7.96342 15.9582 8.09205 15.9011 8.19174 15.8079L9.66249 14.4244C9.85676 14.2419 9.92109 13.9637 9.82647 13.7166L9.42915 12.6734C9.32318 12.3964 8.97377 12.3021 8.73918 12.4883L8.1362 12.9677L7.98487 8.08461C9.65114 7.87475 11.0008 7.89834 11.9746 7.98651L11.3906 8.55777C11.1964 8.74656 11.1648 9.04458 11.3124 9.2706L11.8523 10.0928C12.0213 10.3511 12.3934 10.3784 12.6003 10.1474L14.568 7.94923C14.7573 7.73813 14.8771 7.47607 14.9112 7.19669L14.9931 6.54097C15.0297 6.2429 14.9187 5.94731 14.6954 5.74364L12.7529 3.98514C12.4981 3.75416 12.0932 3.81128 11.9128 4.10188L11.9103 4.10064Z"
      fill="currentColor"
    />
  </svg>
);
